import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: {
          account_created: 'Account created successfully. Please check your email to verify your account.',
          account_verified: 'Account verified successfully. You can now log in.',
          registration_success: 'User registered successfully. Please check your email to verify your account.',
          adDeleteError: 'Error deleting ad. Please try again later.',
          adDeleted: 'Ad deleted successfully.',
          adListEmpty: 'No ads found. Please check back later or post your own ad.',
          adListError: 'Error fetching ads. Please try again later.',
          adNotFound: 'Ad not found.',
          adPostError: 'Error posting ad. Please try again later.',
          adPosted: 'Ad posted successfully.',
          adUpdateError: 'Error updating ad. Please try again later.',
          adUpdated: 'Ad updated successfully.',
          ads: 'Ads',
          category: 'Category',
          categoryListEmpty: 'No categories found. Please check back later.',
          // Product conditions
          condition: 'Condition',
          condition_new: 'Brand New',
          condition_like_new: 'Like New',
          condition_good: 'Good',
          condition_fair: 'Fair',
          condition_poor: 'Poor',
          listing_type: 'Listing Type',
          for_sale: 'For Sale',
          for_rent: 'For Rent',
          categoryListError: 'Error fetching categories. Please try again later.',
          categoryNotFound: 'Category not found.',
          changePassword: 'Change Password',
          confirm_password: 'Confirm Password',
          contactDescription: 'If you have any questions or need assistance, please fill out the form below and we will get back to you as soon as possible.',
          contactEmail: 'Your Email',
          contactError: 'Error sending message. Please try again later.',
          contactForm: 'Contact Form',
          contactMessage: 'Your Message',
          contactName: 'Your Name',
          contactSend: 'Send Message',
          contactSuccess: 'Your message has been sent successfully. We will get back to you shortly.',
          contactUs: 'Contact Us',
          'Contact via WhatsApp': 'Contact via WhatsApp',
          create_in: 'Created on:',
          created_by: 'Created by:',  
          delete: 'Delete',
          deleteAccount: 'Delete Account',
          deleteAccountConfirmation: 'Are you sure you want to delete your account? This action cannot be undone.',
          deleteAccountError: 'Error deleting account. Please try again later.',
          deleteAccountSuccess: 'Your account has been deleted successfully.',
          deleteConfirm: 'Are you sure you want to delete this ad? This action cannot be undone.',
          deleteSuccess: 'Your account has been deleted successfully.',
          description: 'Description',
          edit: 'Edit',
          editProfile: 'Edit Profile',
          email: 'E-mail',
          email_already_exists: 'Email already exists.',
          email_verification_error: 'Error sending email verification link. Please try again later.',
          email_verification_sent: 'Email verification link sent. Please check your inbox.',
          error: 'An error occurred.',
          fill_all_required_fields: 'Please fill in all required fields including postal code.',
          homeDescription: 'Welcome to our marketplace! Here you can buy, sell, rent, and trade easily. Enjoy exploring the latest ads and categories tailored for you.',
          image: 'Image',
          markAsSold: 'Mark as Sold',
          markAsSoldConfirm: 'Are you sure you want to mark this ad as sold?',
          markAsSoldSuccess: 'Ad marked as sold successfully.',
          markAsSoldError: 'Error marking ad as sold.',
          reactivate: 'Reactivate',
          reactivateConfirm: 'Are you sure you want to reactivate this ad?',
          reactivateSuccess: 'Ad reactivated successfully.',
          reactivateError: 'Error reactivating ad.',
          sold: 'Sold',
          statusActive: 'Active',
          statusInactive: 'Inactive',
          statusPending: 'Pending',
          statusSold: 'Sold',
          statusDraft: 'Draft',
          statusRejected: 'Rejected',
          imageRequired: 'Image is required.',
          imageUpload: 'Upload Image',
          imageUploadDescription: 'You can upload multiple images. The first image will be the main one.',
          imageUploadError: 'Error uploading image. Please try again later.',
          imageUploadSuccess: 'Image uploaded successfully.',
          image_optimization_info: 'Images will be automatically optimized to less than 200KB in WebP format',
          invalid_credentials: 'Invalid credentials.',
          loading: 'Loading...',
          location: 'Location',
          location_hint: 'Click on the map to mark the approximate location of your item, or use the geolocation button to use your current location',
          location_title: 'Item Location',
          get_location: 'Get my current location',
          use_current_location: 'Using your current location',
          getting_location: 'Getting location...',
          postal_code: 'Postal Code (Indonesia)',
          postal_code_placeholder: 'E.g.: 12190 (Jakarta)',
          search_location: 'Search location',
          searching: 'Searching...',
          postal_code_help: 'Enter a 5-digit Indonesian postal code (e.g.: 12190 for Jakarta, 40111 for Bandung) to automatically locate on the map.',
          postal_code_required: 'Please enter a postal code',
          postal_code_required_message: 'Postal code is required to publish the ad',
          postal_code_invalid_format: 'Postal code must be exactly 5 numeric digits',
          postal_code_invalid_range: 'Invalid postal code for Indonesia',
          postal_code_not_found: 'Postal code not found in Indonesia',
          postal_code_search_error: 'Error searching postal code',
          geolocation_error: 'Unable to retrieve your location',
          postal_code_found: 'Postal code found',
          location_info_not_found: 'Location information not available',
          no_postal_code_found: 'No postal code found for this point',
          loadingAd: 'Loading ad...',
          loadingAdError: 'Error loading ad. Please try again later.',
          loadingAds: 'Loading ads...',
          loadingAdsError: 'Error loading ads. Please try again later.',
          loadingCategories: 'Loading categories...',
          loadingCategoriesError: 'Error loading categories. Please try again later.',
          loadingContactForm: 'Loading contact form...',
          loadingContactFormError: 'Error loading contact form. Please try again later.',
          loadingError: 'Error loading data. Please try again later.',
          loadingPrivacy: 'Loading privacy policy...',
          loadingPrivacyError: 'Error loading privacy policy. Please try again later.',
          loadingProfile: 'Loading profile...',
          loadingProfileError: 'Error loading profile. Please try again later.',
          loadingTerms: 'Loading terms and conditions...',
          loadingTermsError: 'Error loading terms and conditions. Please try again later.',
          logotipe: 'Buy, Rent, Sell, Trade, and More',
          login: 'Login',
          email_or_phone: 'Email or Phone',
          email_or_phone_placeholder: 'Enter your email or phone number',
          logout: 'Logout',
          myAccount: 'My Account',
          myads: 'My Ads',
          totalAds: 'Total Ads',
          activeAds: 'Active',
          soldAds: 'Sold',
          totalViews: 'Total Views',
          settings: 'Settings',
          favorites: 'Favorites',
          messages: 'Messages',
          statistics: 'Statistics',
          searchAds: 'Search ads...',
          sortNewest: 'Newest First',
          sortOldest: 'Oldest First',
          sortPriceHigh: 'Highest Price',
          sortPriceLow: 'Lowest Price',
          sortViews: 'Most Viewed',
          all: 'All',
          gridView: 'Grid',
          listView: 'List',
          noResults: 'No results found',
          tryDifferentSearch: 'Try a different search or adjust your filters',
          startPosting: 'Start posting ads',
          postFirstAd: 'Click here to post your first ad',
          noAdsMessage: 'You haven\'t posted any ads yet',
          name: 'Name',
          optional: 'Optional',
          negotiable_price: 'Negotiable Price',
          // Messages
          signin_required_message: 'You must log in to send messages',
          please_write_message: 'Please write a message',
          message_sent_successfully: 'Message sent successfully',
          error_sending_message: 'Error sending message',
          loading_messages: 'Loading messages...',
          no_messages_yet: 'No messages yet',
          start_conversation: 'Start the conversation!',
          type_message: 'Type a message...',
          seller: 'Seller',
          Speak_with_seller: 'Contact Seller',
          // Offers
          make_offer: 'Make an Offer',
          send_offer: 'Send Offer',
          offer_amount: 'Offer Amount',
          offer_message: 'Message (optional)',
          offer_sent: 'Offer sent successfully',
          offer_error: 'Error sending offer',
          enter_amount: 'Enter your offer amount',
          offer_too_low: 'Offer amount must be greater than 0',
          pending_offers: 'Pending Offers',
          no_offers_yet: 'No offers yet',
          accept_offer: 'Accept',
          reject_offer: 'Reject',
          counter_offer: 'Counter',
          offer_accepted: 'Offer accepted!',
          offer_rejected: 'Offer rejected',
          offer_countered: 'Counteroffer sent',
          your_offer: 'Your offer:',
          seller_response: 'Seller response:',
          // User type
          user_type: 'User Type',
          particular: 'Private Seller',
          professional: 'Professional',
          select_user_type: 'Select your user type',
          cancel: 'Cancel',
          noAds: 'It looks like no ads have been posted yet...',
          notFound: 'Page Not Found',
          notFoundBackHome: 'Go back to Home',
          notFoundDescription: 'The page you are looking for does not exist or has been moved. Please check the URL or return to the homepage.',
          noResultsFound: 'No results found for your search.',  
          passwrd: 'Password',
          phone: 'Mobile Phone',
          phone_examples: 'Examples: +1 5551234567 (USA), +44 7911123456 (UK), +55 11999999999 (Brazil), +34 612345678 (Spain)',
          phone_format_error: 'Please enter a valid international phone number (e.g., +1 5551234567, +55 11999999999)',
          phone_placeholder: '+1 5551234567',
          password: 'Password',
          passwordChanged: 'Password changed successfully.',
          passwordChangeError: 'Error changing password. Please try again later.',
          password_confirmation: 'Confirm Password',
          password_reset: 'Password reset successfully. You can now log in with your new password.',
          password_reset_error: 'Error sending password reset link. Please try again later.',
          password_reset_link_sent: 'Password reset link sent to your email. Please check your inbox.',
          postAd: 'Post an Ad +',
          postAdButton: 'Post an Ad',
          price: 'Price',
          price_required: 'Price is required or mark as negotiable',
          priceNegotiable: 'Price Negotiable',
          'Price Range': 'Price Range',
          'Min': 'Min',
          'Max': 'Max',
          'All': 'All',
          'Newest First': 'Newest First',
          'Oldest First': 'Oldest First',
          'Price: Low to High': 'Price: Low to High',
          'Price: High to Low': 'Price: High to Low',
          'Most Viewed': 'Most Viewed',
          'Results': 'Results',
          privacyDescription: 'Your privacy is important to us. Please read our privacy policy to understand how we collect, use, and protect your information.',
          privacyPolicy: 'Privacy Policy',
          privacyPolicyLink: 'Privacy Policy',
          profileUpdateError: 'Error updating profile. Please try again later.',
          profileUpdated: 'Profile updated successfully.',
          profileSettings: 'Profile Settings',
          basicInformation: 'Basic Information',
          updateBasicInfo: 'Update your personal information',
          manageEmailSettings: 'Manage your email and verification',
          managePhoneSettings: 'Manage your phone number and verification',
          updatePasswordSecurity: 'Change your password to keep your account secure',
          oauthLogin: 'OAuth Login',
          enterName: 'Enter your name',
          enterState: 'Enter your state',
          selectState: 'Select your province',
          updateProfile: 'Update Profile',
          emailAddress: 'Email Address',
          enterEmail: 'Enter your email',
          updateEmail: 'Update Email',
          resendVerification: 'Resend Verification',
          emailVerificationRequired: 'A verification email will be sent to your new email address',
          phoneNumber: 'Phone Number',
          updatePhone: 'Update Phone',
          resendCode: 'Resend Code',
          verificationCode: 'Verification Code',
          verifyPhone: 'Verify Phone',
          phoneVerificationRequired: 'A verification code will be sent to your phone',
          phoneVerificationCodeSent: 'A verification code has been sent to your phone. Please enter the 6-digit code.',
          phoneVerificationSentTo: 'We sent a verification code to:',
          phoneVerifiedSuccess: 'Phone verified successfully! Redirecting to login...',
          verificationCodeResent: 'Verification code resent successfully.',
          enterVerificationCode: 'Please enter the 6-digit verification code',
          didntReceiveCode: "Didn't receive the code?",
          verify: 'Verify Code',
          verifyNow: 'Verify Now',
          phoneVerifyModal: 'Phone Verification',
          phoneAlreadyInUse: 'Phone number already in use',
          phoneAlreadyInUseMessage: 'This phone number is already registered to another account. Please use a different number.',
          codeSentSuccess: 'Verification code sent successfully',
          codeSentError: 'Error sending verification code',
          codeVerifySuccess: 'Phone verified successfully',
          codeVerifyError: 'Invalid or expired verification code',
          resendCodeIn: 'Resend code in {{seconds}}s',
          resendCodeAvailable: 'Resend Code',
          enterCodePlaceholder: 'Enter 4-digit code',
          codeExpiresWarning: 'Code expires in 60 seconds. Please enter it quickly.',
          currentPassword: 'Current Password',
          enterCurrentPassword: 'Enter current password',
          newPassword: 'New Password',
          enterNewPassword: 'Enter new password',
          confirmNewPassword: 'Confirm new password',
          oauthAccount: 'You signed in with {{provider}}. Password changes are not available.',
          verified: 'Verified',
          notVerified: 'Not Verified',
          register: 'Register',
          registerDescription: 'Create your account to start posting ads and exploring our marketplace. Fill in the form below to get started.',
          remember_me: 'Remember me',
          search: 'Search in the site...',
          searchButton: 'Search',
          seeAll: 'See all >>',
          sign_in: 'Sign In',
          sign_in_with_google: 'Sign in with Google',
          sign_up: 'Sign Up',
          sign_up_with_google: 'Sign up with Google',
          phone_verification_required: 'Phone Verification Required',
          phone_verification_required_message: 'Your account requires phone verification before you can log in. This helps us keep the platform secure and prevents spam.',
          verify_phone_now: 'Verify Phone Now',
          speak_with_seller: 'Speak with the seller',
          speak_with_seller_description: 'If you have any questions about this ad, you can contact the seller directly via email.',
          state: 'State',
          stateAll: 'All',
          termsAndConditions: 'Terms and Conditions',
          termsAndConditionsLink: 'Terms and Conditions',
          termsDescription: 'Please read our terms and conditions carefully before using our marketplace. By using our site, you agree to comply with these terms.',
          title: 'Title',
          token_invalid: 'Invalid or expired token.',
          token_not_provided: 'Token not provided.',
          user_not_found: 'User not found.',
          verifying: 'Verifying...',
          emailVerified: 'Email verified successfully. You can now log in.',
          view: 'View',
          viewers: 'Viewers',
          viewAd: 'View Ad',
          contacts: 'contacts',
          must_login_favorites: 'You must log in to add favorites',
          must_login_messages: 'You must log in to send messages',
          interested_whatsapp: 'Hi, I am interested in your ad:',
          offer_sent_message: 'I have sent an offer of Rp {{amount}}',
          welcome: 'Welcome to our marketplace! Here you can buy, sell, rent, and trade easily. Enjoy exploring the latest ads and categories tailored for you.',
          welcomeBack: 'Welcome back, {{name}}! You can manage your ads and profile here.',
          welcomeNewUser: 'Welcome! Please create your account to start posting ads and exploring our marketplace.',
          welcomeTitle: 'Welcome to Terserah! 🎉',
          welcomeText: 'Welcome to Terserah! We are happy to welcome you to Terserah, your new online space where you can find all kinds of products at the best price. From second-hand items in excellent condition to unique opportunities you won’t want to miss, Terserah is the ideal place to buy and sell easily, quickly, and safely. On our platform, you can explore a wide variety of categories: technology, fashion, home, sports, toys, vehicles, and much more! Whether you are looking for something specific or just browsing out of curiosity, we are sure you will find something interesting. Also, if you have products you no longer use, upload them to Terserah and find someone who needs them. Recycle, earn money, and help the planet at the same time! Thank you for trusting us. Start exploring now and discover everything Terserah has for you.',
          whatareYouLookingFor: 'What are you looking for?',
          featuredAds: 'Featured Ads ⭐',
          whatIsYourName: 'What is your name?',          // Categories
          'Electronics': 'Electronics',
          'Smartphones': 'Smartphones',
          // Stats and How it Works
          'Active Ads': 'Active Ads',
          'Categories': 'Categories',
          '100% Free': '100% Free',
          'To Publish': 'To Publish',
          'How It Works': 'How It Works',
          'Search': 'Search',
          'Browse thousands of ads in all categories': 'Browse thousands of ads in all categories',
          'Contact': 'Contact',
          'Message sellers directly to negotiate': 'Message sellers directly to negotiate',
          'Deal': 'Deal',
          'Meet safely and complete your transaction': 'Meet safely and complete your transaction',
          'Recent Ads': 'Recent Ads',
          'Computers and Laptops': 'Computers and Laptops',
          'Consoles and Videogames': 'Consoles and Videogames',
          'Cameras and Photography': 'Cameras and Photography',
          'Small Appliances': 'Small Appliances',
          'Home and Furniture': 'Home and Furniture',
          'Furniture': 'Furniture',
          'Decoration': 'Decoration',
          'Kitchen and Utensils': 'Kitchen and Utensils',
          'Garden and Outdoor': 'Garden and Outdoor',
          'Lighting': 'Lighting',
          'Fashion and Accessories': 'Fashion and Accessories',
          'Clothing': 'Clothing',
          'Footwear': 'Footwear',
          'Bags and Backpacks': 'Bags and Backpacks',
          'Watches and Jewelry': 'Watches and Jewelry',
          'Accessories': 'Accessories',
          'Motor': 'Motor',
          'Cars': 'Cars',
          'Motorcycles': 'Motorcycles',
          'Vehicle Accessories': 'Vehicle Accessories',
          'Spare Parts': 'Spare Parts',
          'Tools and Maintenance': 'Tools and Maintenance',
          'Leisure, Sports and Others': 'Leisure, Sports and Others',
          'Sports and Fitness': 'Sports and Fitness',
          'Bicycles': 'Bicycles',
          'Musical Instruments': 'Musical Instruments',
          'Toys and Games': 'Toys and Games',
          'Books and Collectibles': 'Books and Collectibles',
          // Services Category
          'Services': 'Rental & Services',
          'Cleaning & Housekeeping': 'Cleaning & Housekeeping',
          'Construction & Renovation': 'Construction & Renovation',
          'Education & Tutoring': 'Education & Tutoring',
          'Events & Catering': 'Events & Catering',
          'Beauty & Wellness': 'Beauty & Wellness',
          'Technical Support & IT': 'Technical Support & IT',
          'Transportation & Delivery': 'Transportation & Delivery',
          'Legal & Consulting': 'Legal & Consulting',
          'Photography & Design': 'Photography & Design',
          'Other Services': 'Other Services',
          otherSellerAds: 'Other seller offers',
          
          // Common legal terms
          lastUpdated: 'Last updated',
          company: 'PT World Systems Consulting',
          platform: 'Terserah',
          country: 'Indonesia',
          
          // Privacy Policy
          privacy_title: 'Privacy Policy',
          privacy_introduction_title: 'Introduction',
          privacy_introduction_content: 'This Privacy Policy explains how Terserah ("we," "us," or "our") collects, uses, discloses, and protects the personal information of users ("you") who access and use our platform at https://terserah.id. By using our services, you consent to the collection and use of information in accordance with this policy.',
          
          privacy_information_title: 'Information We Collect',
          privacy_information_intro: 'We collect several types of information to provide and improve our services to you:',
          privacy_information_personal: 'Personal Information:',
          privacy_information_personal_content: 'Name, email address, phone number, address, profile photo, and other information you provide when registering an account or posting ads.',
          privacy_information_transactional: 'Transaction Information:',
          privacy_information_transactional_content: 'Details of transactions you make through our platform, including ads you buy, sell, or bid on.',
          privacy_information_technical: 'Technical Information:',
          privacy_information_technical_content: 'IP address, browser type, device used, operating system, pages visited, and access times.',
          privacy_information_usage: 'Usage Data:',
          privacy_information_usage_content: 'Information about how you use our platform, such as searches performed, ads viewed, and interactions with other users.',
          privacy_information_location: 'Location Data:',
          privacy_information_location_content: 'If you allow it, we collect your location information to display relevant ads based on your geographical location.',
          privacy_user_provided: 'Information You Provide',
          privacy_user_name: 'Full name',
          privacy_user_phone: 'Phone number',
          privacy_user_email: 'Email address',
          privacy_user_photo: 'Profile photo',
          privacy_user_listings: 'Listing information (title, description, price, images)',
          privacy_auto_collected: 'Automatically Collected Information',
          privacy_auto_ip: 'IP address and connection details',
          privacy_auto_device: 'Device type and model',
          privacy_auto_browser: 'Browser type and version',
          privacy_auto_usage: 'Pages visited and usage patterns',
          
          privacy_purpose_title: 'Purpose of Information Use',
          privacy_purpose_intro: 'We use the information collected to:',
          privacy_purpose_platform: 'Provide, operate, and maintain our platform.',
          privacy_purpose_personalize: 'Personalize user experience by displaying relevant ads.',
          privacy_purpose_communicate: 'Communicate with you regarding our services, including notifications, updates, and customer support.',
          privacy_purpose_transactions: 'Facilitate transactions between users.',
          privacy_purpose_security: 'Monitor and improve platform security, including fraud detection and prevention.',
          privacy_purpose_analytics: 'Analyze platform usage to improve our services.',
          privacy_purpose_legal: 'Comply with applicable legal and regulatory obligations.',
          privacy_purpose_accounts: 'Create and manage user accounts',
          privacy_purpose_communication: 'Communicate with users about services and support',
          privacy_purpose_display: 'Display relevant ads based on location and preferences',
          privacy_purpose_improve: 'Improve and optimize the platform',
          privacy_purpose_prevent: 'Prevent fraud and ensure security',
          privacy_purpose_comply: 'Comply with legal and regulatory requirements',
          
          privacy_legal_title: 'Legal Basis for Data Processing',
          privacy_legal_intro: 'We process your personal data based on the following legal bases:',
          privacy_legal_contract: 'Performance of the contract with you when using our services.',
          privacy_legal_interest: 'Our legitimate interest in operating and improving the platform.',
          privacy_legal_consent: 'Your explicit consent for data collection and processing',
          privacy_legal_compliance: 'Compliance with legal obligations.',
          privacy_legal_business: 'Legitimate business interests in improving our services',
          
          privacy_sharing_title: 'Sharing Information with Third Parties',
          privacy_sharing_intro: 'We do not sell your personal information. However, we may share your information in the following situations:',
          privacy_sharing_no_sell: 'We do not sell your personal information to third parties.',
          privacy_sharing_providers: 'Service providers who help us operate the platform (hosting, analytics)',
          privacy_sharing_providers_content: 'We may share information with service providers who help us operate the platform, such as hosting providers, payment services, and analytics tools.',
          privacy_sharing_authorities: 'Law enforcement or regulatory authorities when required by law',
          privacy_sharing_partners: 'We may share anonymized data with partners for analytics and improvement purposes.',
          privacy_sharing_users: 'Other Users:',
          privacy_sharing_users_content: 'Certain information, such as name, email, and phone number, may be visible to other users when you post ads or contact sellers.',
          privacy_sharing_legal: 'Legal Compliance:',
          privacy_sharing_legal_content: 'We may disclose your information if required by law or to protect our rights, property, or safety, that of our users, or others.',
          privacy_sharing_business: 'Business Transfers:',
          privacy_sharing_business_content: 'In the event of a merger, acquisition, or sale of our assets, user information may be transferred as part of that transaction.',
          
          privacy_storage_title: 'Data Storage and Security',
          privacy_storage_intro: 'We take reasonable steps to protect your personal information from unauthorized access, alteration, disclosure, or destruction. Our data is stored on secure servers, and we apply encryption and other security measures to protect your information.',
          privacy_storage_https: 'Use of HTTPS encryption for data transmission',
          privacy_storage_servers: 'Secure servers with restricted access',
          privacy_storage_access: 'Limited employee access to personal data on a need-to-know basis',
          privacy_storage_warning: 'However, no method of transmission over the Internet or electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your personal information, we cannot guarantee its absolute security.',
          
          privacy_retention_title: 'Data Retention',
          privacy_retention_content: 'We retain your personal information while your account is active or as necessary to provide our services. After you delete your account, we will delete or anonymize your personal information, unless we are required by law to retain it.',
          privacy_retention_intro: 'We retain your data according to the following principles:',
          privacy_retention_active: 'Active account data is retained while your account is active',
          privacy_retention_legal: 'Some data may be retained to comply with legal obligations',
          privacy_retention_deletion: 'You can request account deletion at any time through your account settings.',
          
          privacy_rights_title: 'Your Rights',
          privacy_rights_intro: 'You have the following rights related to your personal information:',
          privacy_rights_access: 'Access:',
          privacy_rights_access_content: 'You can request a copy of the personal information we hold about you.',
          privacy_rights_correction: 'Correction:',
          privacy_rights_correction_content: 'You can request us to update or correct your personal information that is inaccurate or incomplete.',
          privacy_rights_correct: 'Request correction of inaccurate personal data',
          privacy_rights_withdraw: 'Withdraw consent for data processing at any time',
          privacy_rights_delete: 'Request deletion of your personal data',
          privacy_rights_complain: 'Lodge a complaint with a data protection authority',
          privacy_rights_deletion: 'Deletion:',
          privacy_rights_deletion_content: 'You can request us to delete your personal information, subject to certain conditions.',
          privacy_rights_objection: 'Objection:',
          privacy_rights_objection_content: 'You can object to the processing of your personal information in certain situations.',
          privacy_rights_restriction: 'Restriction:',
          privacy_rights_restriction_content: 'You can request us to restrict the processing of your personal information.',
          privacy_rights_portability: 'Data Portability:',
          privacy_rights_portability_content: 'You can request a copy of your data in a machine-readable format.',
          privacy_rights_exercise: 'To exercise these rights, please contact us at',
          privacy_rights_contact: 'To exercise any of these rights, please contact us at info@terserah.id',
          
          privacy_cookies_title: 'Cookies and Tracking Technologies',
          privacy_cookies_content: 'We use cookies and similar tracking technologies to enhance user experience and analyze website traffic. Cookies are small files stored on your device that help us recognize you and remember your preferences. You can manage your cookie preferences through your browser settings, but disabling cookies may affect the functionality of our platform.',
          privacy_cookies_intro: 'We use cookies and similar technologies for:',
          privacy_cookies_experience: 'Improving user experience and remembering preferences',
          privacy_cookies_analyze: 'Analyzing traffic and usage patterns',
          privacy_cookies_security: 'Maintaining security and preventing fraud',
          privacy_cookies_disable: 'You can manage cookie preferences in your browser settings.',
          
          privacy_thirdparty_title: 'Third-Party Links',
          privacy_thirdparty_content: 'Our platform may contain links to third-party websites. We are not responsible for the privacy practices or content of such websites. We encourage you to read the privacy policies of each website you visit.',
          
          privacy_changes_title: 'Changes to this Privacy Policy',
          privacy_changes_content: 'We may update this Privacy Policy from time to time to reflect changes to our practices or for other operational, legal, or regulatory reasons. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last Updated" date at the top.',
          
          privacy_contact_title: 'Contact Us',
          privacy_contact_content: 'If you have questions or concerns about this Privacy Policy or our privacy practices, please contact us at:',
          privacy_contact_intro: 'For questions about this Privacy Policy or our privacy practices, please contact:',
          privacy_contact_email: 'Email: info@terserah.id',
          privacy_contact_address: 'Address: PT World Systems Consulting, Indonesia',
          
          // Terms and Conditions
          terms_title: 'Terms and Conditions',
          
          terms_acceptance_title: 'Acceptance of Terms',
          terms_acceptance_content: 'By accessing or using the Terserah platform ("Platform"), you agree to be bound by these Terms and Conditions. If you do not agree with these terms, do not use our Platform.',
          
          terms_service_title: 'Service Description',
          terms_service_content: 'Terserah is an online marketplace that facilitates the buying, selling, renting, and exchanging of goods and services between users in Indonesia. The platform does not act as a seller or buyer, but as an intermediary connecting users.',
          terms_service_warning: 'Terserah is not responsible for transactions between users. All transactions are the sole responsibility of buyers and sellers.',
          
          terms_eligibility_title: 'Eligibility',
          terms_eligibility_content: 'You must be at least 18 years old or have parental/guardian permission to use our Platform. By registering, you warrant that you have the legal authority to enter into a binding agreement.',
          terms_eligibility_age: 'Be at least 18 years old or have parental/guardian consent.',
          terms_eligibility_accurate: 'Provide accurate and truthful information during registration.',
          terms_eligibility_one_account: 'Maintain only one account per person.',
          
          terms_accounts_title: 'User Accounts',
          terms_accounts_registration: 'Registration:',
          terms_accounts_registration_content: 'You must create an account to access some features of the Platform. You are responsible for providing accurate and complete information during the registration process.',
          terms_accounts_security: 'Account Security:',
          terms_accounts_security_content: 'You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account. Report any unauthorized use to us immediately.',
          terms_accounts_termination: 'Account Termination:',
          terms_accounts_termination_content: 'We reserve the right to suspend or terminate your account at any time if you violate these terms or engage in illegal or inappropriate activities.',
          terms_accounts_responsible: 'You are responsible for all activities under your account.',
          terms_accounts_terminate: 'We reserve the right to suspend or terminate accounts that violate our terms.',
          terms_accounts_prohibited: 'Creating multiple accounts or sharing account credentials is prohibited.',
          
          terms_listings_title: 'Listings and Content',
          terms_listings_intro: 'Users are prohibited from posting ads for the following items:',
          terms_listings_illegal: 'Drugs, narcotics, or illegal substances.',
          terms_listings_weapons: 'Firearms, weapons, or explosives.',
          terms_listings_counterfeit: 'Counterfeit, pirated, or fraudulent products.',
          terms_listings_animals: 'Endangered or protected animals without proper authorization.',
          terms_listings_adult: 'Adult content or sexually explicit material.',
          terms_listings_review: 'We reserve the right to review and remove any listings that violate these terms.',
          terms_listings_responsibility: 'User Responsibility:',
          terms_listings_responsibility_content: 'Users are fully responsible for the content they post, including ads, images, descriptions, and other information. You warrant that your content does not infringe third-party rights or applicable laws.',
          terms_listings_prohibited: 'Prohibited Items:',
          terms_listings_prohibited_content: 'You may not post ads for items prohibited by Indonesian law or contrary to our policy, including but not limited to: drugs, firearms, stolen goods, counterfeit products, or offensive or illegal content.',
          terms_listings_moderation: 'Content Moderation:',
          terms_listings_moderation_content: 'We reserve the right to review, edit, or remove any content that violates these terms or is deemed inappropriate, without prior notice.',
          
          terms_transactions_title: 'Transactions',
          terms_transactions_responsibility: 'User Responsibility:',
          terms_transactions_responsibility_content: 'Transactions occurring through the Platform are between the buyer and seller. Terserah is not responsible for the quality, safety, or legality of items traded, or the seller\'s ability to complete the transaction.',
          terms_transactions_disputes: 'Dispute Resolution:',
          terms_transactions_disputes_content: 'Users are responsible for resolving disputes that may arise from their transactions. We may help facilitate communication, but we are not responsible for mediating or resolving disputes.',
          terms_transactions_between: 'All transactions are directly between buyers and sellers.',
          terms_transactions_no_guarantee: 'Terserah does not guarantee the quality, safety, or legality of items listed.',
          terms_transactions_risks: 'Users assume all risks associated with transactions and must exercise caution.',
          
          terms_fees_title: 'Fees',
          terms_fees_current: 'Currently, posting and browsing ads on Terserah is completely free.',
          terms_fees_future: 'We reserve the right to introduce fees for premium features in the future, with advance notice to users.',
          terms_fees_content: 'Basic use of the Platform is free. However, we may charge fees for premium services or additional features in the future. Fee changes will be announced on the Platform.',
          
          terms_conduct_title: 'User Conduct',
          terms_conduct_intro: 'When using the Platform, you agree not to:',
          terms_conduct_laws: 'Violate applicable laws or regulations.',
          terms_conduct_fraud: 'Engage in fraudulent, misleading, or deceptive activities.',
          terms_conduct_harass: 'Harass, threaten, defame, or abuse other users.',
          terms_conduct_manipulate: 'Attempt to manipulate prices, reviews, or search rankings.',
          terms_conduct_circumvent: 'Circumvent or interfere with security features of the Platform.',
          terms_conduct_others: 'Harass, threaten, or abuse other users.',
          terms_conduct_interfere: 'Interfere with or damage the functionality of the Platform.',
          terms_conduct_bots: 'Use bots, scrapers, or other automated tools without our permission.',
          terms_conduct_impersonate: 'Impersonate another person or entity.',
          
          terms_ip_title: 'Intellectual Property',
          terms_ip_content: 'All content, logos, trademarks, and other materials on the Platform are owned by PT World Systems Consulting or its licensors and are protected by intellectual property laws. You may not use, reproduce, or distribute our content without written permission.',
          
          terms_liability_title: 'Limitation of Liability',
          terms_liability_intro: 'To the extent permitted by law:',
          terms_liability_asis: 'Terserah provides the Platform "as is" without any warranties, express or implied.',
          terms_liability_nodamages: 'We are not liable for direct, indirect, incidental, or consequential damages arising from the use or inability to use the Platform.',
          terms_liability_noliability: 'We are not liable for the actions or omissions of users, or for transactions conducted through the Platform.',
          terms_liability_not_liable: 'Terserah is not liable for any losses, damages, or disputes arising from user transactions.',
          terms_liability_not_responsible: 'We are not responsible for the accuracy, quality, or legality of user-posted content.',
          
          terms_privacy_title: 'Privacy',
          terms_privacy_content: 'The use of your personal information is governed by our Privacy Policy, which is part of these Terms and Conditions. Please read the Privacy Policy to understand how we collect, use, and protect your data.',
          
          terms_termination_title: 'Termination',
          terms_termination_content: 'We reserve the right to suspend or terminate your access to the Platform at any time, with or without cause, and without prior notice. Upon termination, you must cease using the Platform, and all rights granted to you under these terms will cease.',
          
          terms_law_title: 'Governing Law',
          terms_law_content: 'These Terms and Conditions are governed by and construed in accordance with the laws of Indonesia. Any disputes arising from or related to these terms shall be resolved in the courts of Indonesia.',
          terms_governing_title: 'Governing Law',
          terms_governing_content: 'These Terms and Conditions are governed by and construed in accordance with the laws of Indonesia. Any disputes shall be resolved in Indonesian courts.',
          
          terms_contact_title: 'Contact Us',
          terms_contact_content: 'If you have questions about these Terms and Conditions, please contact us at:',
          terms_contact_intro: 'If you have any questions or concerns about these Terms and Conditions, please contact us:',
          terms_contact_email: 'Email: info@terserah.id',
          terms_contact_address: 'Address: PT World Systems Consulting, Indonesia',

          // Notifications
          notifications_title: 'Notifications',
          notifications_none: 'No notifications',
          notifications_mark_read: 'Mark as read',
          notifications_mark_all_read: 'Mark all as read',
          notifications_delete: 'Delete',
          notifications_new: 'New notification',
          notification_message: 'sent you a message',
          notification_offer_received: 'sent you an offer',
          notification_offer_accepted: 'accepted your offer',
          notification_offer_rejected: 'rejected your offer',
          notification_offer_countered: 'countered your offer',
          notification_review_received: 'left you a review',
          notification_ad_sold: 'Your ad has been marked as sold',
          notification_ad_expired: 'Your ad has expired',
          notification_price_drop: 'Price drop on an ad you saved',
          notification_saved_search_match: 'New ad matches your saved search',
          notification_follow_new_ad: 'posted a new ad',

          // Offers
          offers_title: 'Offers',
          offers_none: 'No offers yet',
          offers_received: 'Received Offers',
          offers_sent: 'Sent Offers',
          offers_make: 'Make Offer',
          offers_accept: 'Accept',
          offers_reject: 'Reject',
          offers_counter: 'Counter Offer',
          offers_pending: 'Pending',
          offers_accepted: 'Accepted',
          offers_rejected: 'Rejected',
          offers_countered: 'Countered',
          offers_expired: 'Expired',
          offers_amount: 'Offer Amount',
          offers_message: 'Message',
          offers_expires: 'Expires in',
          offers_expired_on: 'Expired on',
          offers_status: 'Status',

          // Verification Badges
          verification_elite: 'Elite Seller',
          verification_pro: 'Pro Seller',
          verification_trusted: 'Trusted Seller',
          verification_verified: 'Verified User',
          verification_new: 'New User',
          verification_level: 'Verification Level',

          // Biography
          biography: 'Biography',
          biographyPlaceholder: 'Tell us about yourself...',
          characters: 'characters',
          
          // Reviews
          reviews: 'reviews',
          review: 'review',
          leave_review: 'Leave a review',
          leave_review_title: 'Leave a review',
          review_rating_label: 'Rating *',
          review_comment_label: 'Comment (optional)',
          review_comment_placeholder: 'Share your experience with this user...',
          review_submit: 'Submit review',
          review_submitting: 'Submitting...',
          review_success: 'Review submitted successfully',
          review_error: 'Error submitting review',
          review_rating_required: 'Please select a rating',
          review_rating_very_bad: 'Very bad',
          review_rating_bad: 'Bad',
          review_rating_average: 'Average',
          review_rating_good: 'Good',
          review_rating_excellent: 'Excellent',
          reviews_title: 'Reviews ({{count}})',
          reviews_loading: 'Loading reviews...',
          reviews_empty: 'This user has no reviews yet',
          reviews_load_more: 'Load more reviews',
          reviews_ad_reference: '📦 Ad: {{title}}',
          reviews_user_label: 'User',
          reviews_today: 'Today',
          reviews_yesterday: 'Yesterday',
          reviews_days_ago: '{{days}} days ago',
          reviews_weeks_ago: '{{weeks}} weeks ago',
          reviews_months_ago: '{{months}} months ago',
          reviews_years_ago: '{{years}} years ago',
          
          // Social Share
          share: 'Share',
          share_title_default: 'Check out this ad on Terserah',
          share_description_default: 'I found this interesting ad on Terserah',
          share_link_copied: 'Copied!',
          share_copy_link: 'Copy link',
          
          // Report Ad
          report_ad: '🚩 Report ad',
          report_ad_title: 'Report ad',
          report_ad_subtitle: 'Help us keep the community safe by reporting inappropriate content',
          report_ad_reason_label: 'What is the reason for reporting?',
          report_ad_reason_spam: '📢 Spam or repetitive content',
          report_ad_reason_inappropriate: '🚫 Inappropriate or offensive content',
          report_ad_reason_fraud: '⚠️ Possible fraud or scam',
          report_ad_reason_duplicate: '📋 Duplicate ad',
          report_ad_reason_other: '❓ Other reason',
          report_ad_details_label: 'Additional details (optional)',
          report_ad_details_placeholder: 'Provide more information about the problem...',
          report_ad_cancel: 'Cancel',
          report_ad_submit: 'Submit Report',
          report_ad_submitting: 'Submitting...',
          report_ad_success: 'Report submitted successfully. Our team will review it soon.',
          report_ad_error: 'Error submitting report',
          report_ad_reason_required: 'Please select a reason',
          report_ad_login_required: 'You must be logged in to report ads',

          // Follow System
          follow: 'Follow',
          following: 'Following',
          unfollow: 'Unfollow',
          followers: 'Followers',
          followersCount: '{{count}} followers',
          followingCount: '{{count}} following',
          followingFeed: 'Following Feed',
          noFollowing: 'Not following anyone yet',
          startFollowing: 'Follow users to see their ads here',
          
          // User Profile
          user_profile: 'User Profile',
          user_profile_description: 'View user profile information and statistics',
          error_loading_profile: 'Error loading profile',
          bio_placeholder: 'Tell us about yourself...',
          edit_bio: 'Edit Bio',
          save_bio: 'Save',
          bio_max_length: 'Bio must be less than 500 characters',
          error_saving_bio: 'Error saving bio',
          no_bio_yet: 'Add a bio to tell people about yourself',
          no_bio: 'This user hasn\'t added a bio yet',
          member_since: 'Member since',
          
          // App Download
          download_android_app: 'Download Android App',
          download_ios_app: 'Download iOS App',
          get_it_on: 'GET IT ON',
          download_on: 'Download on the',
          
          // Search
          searchPlaceholder: 'Search products...',
          suggestions: 'Suggestions',
          recentSearches: 'Recent Searches',
          popularSearches: 'Popular Searches',
          relatedSearches: 'Related Searches',
          clearHistory: 'Clear History',
          noRecentSearches: 'No recent searches',
          results: 'results',
          
          // Empty States
          'No data available': 'No data available',
          'There is no content to display at the moment': 'There is no content to display at the moment',
          'Try adjusting your filters or search terms': 'Try adjusting your filters or search terms',
          'Start a conversation by contacting a seller': 'Start a conversation by contacting a seller',
          'Browse ads': 'Browse ads',
          'Save ads you like to find them easily later': 'Save ads you like to find them easily later',
          'Explore ads': 'Explore ads',
          'We\'ll notify you when something happens': 'We\'ll notify you when something happens',
          'Try different keywords or remove some filters': 'Try different keywords or remove some filters',
          'Clear filters': 'Clear filters',
          'Follow users to see their ads in your personalized feed': 'Follow users to see their ads in your personalized feed',
          'Find users': 'Find users',
          'Buyers can make offers on your negotiable items': 'Buyers can make offers on your negotiable items',
          'Something went wrong': 'Something went wrong',
          'Please try again later or contact support': 'Please try again later or contact support',
          'Retry': 'Retry',
          
          // Terms acceptance messages
          agree_terms_privacy: 'I agree to the Terms & Conditions and Privacy Policy',
          by_posting_agree_terms: 'By posting an item, you agree to the',
          terms_and: 'Terms & Conditions',
          
          // Category translations
          'Vehicles': 'Vehicles',
          'Trucks': 'Trucks',
          'Buses': 'Buses',
          'Boats': 'Boats',
          'Vehicle Parts': 'Vehicle Parts',
          'Vehicle Services': 'Vehicle Services',
          'Heavy Machinery': 'Heavy Machinery',
          'Other Vehicles': 'Other Vehicles',
          'Property': 'Property',
          'Houses': 'Houses',
          'Apartments': 'Apartments',
          'Land': 'Land',
          'Commercial Property': 'Commercial Property',
          'Villas': 'Villas',
          'Boarding Houses': 'Boarding Houses',
          'Offices': 'Offices',
          'Warehouses': 'Warehouses',
          'Shops': 'Shops',
          'Other Property': 'Other Property',
          'Phones & Tablets': 'Phones & Tablets',
          'Computers & Laptops': 'Computers & Laptops',
          'TVs & Audio': 'TVs & Audio',
          'Cameras': 'Cameras',
          'Gaming': 'Gaming',
          'Smart Home': 'Smart Home',
          'Wearables': 'Wearables',
          'Drones': 'Drones',
          'Other Electronics': 'Other Electronics',
          'Fashion & Beauty': 'Fashion & Beauty',
          'Mens Fashion': 'Mens Fashion',
          'Womens Fashion': 'Womens Fashion',
          'Kids Fashion': 'Kids Fashion',
          'Bags & Luggage': 'Bags & Luggage',
          'Shoes': 'Shoes',
          'Watches': 'Watches',
          'Jewelry': 'Jewelry',
          'Beauty Products': 'Beauty Products',
          'Skincare': 'Skincare',
          'Other Fashion': 'Other Fashion',
          'Hobbies & Sports': 'Hobbies & Sports',
          'Sports Equipment': 'Sports Equipment',
          'Art & Crafts': 'Art & Crafts',
          'Collectibles': 'Collectibles',
          'Outdoor Gear': 'Outdoor Gear',
          'Fishing': 'Fishing',
          'Cycling': 'Cycling',
          'Gym & Fitness': 'Gym & Fitness',
          'Board Games': 'Board Games',
          'Other Hobbies': 'Other Hobbies',
          'Home & Living': 'Home & Living',
          'Home Appliances': 'Home Appliances',
          'Kitchen & Dining': 'Kitchen & Dining',
          'Bedding': 'Bedding',
          'Home Decor': 'Home Decor',
          'Garden & Outdoor': 'Garden & Outdoor',
          'Tools & DIY': 'Tools & DIY',
          'Bathroom': 'Bathroom',
          'Other Home': 'Other Home',
          'Home Services': 'Home Services',
          'Repair Services': 'Repair Services',
          'Construction': 'Construction',
          'Moving Services': 'Moving Services',
          'Cleaning Services': 'Cleaning Services',
          'Beauty Services': 'Beauty Services',
          'Event Services': 'Event Services',
          'Photography': 'Photography',
          'Legal Services': 'Legal Services',
          'Jobs': 'Jobs',
          'Full Time Jobs': 'Full Time Jobs',
          'Part Time Jobs': 'Part Time Jobs',
          'Freelance': 'Freelance',
          'Internships': 'Internships',
          'Remote Work': 'Remote Work',
          'IT & Software': 'IT & Software',
          'Sales & Marketing': 'Sales & Marketing',
          'Hospitality': 'Hospitality',
          'Education': 'Education',
          'Other Jobs': 'Other Jobs',
          'Food & Beverages': 'Food & Beverages',
          'Home Cooking': 'Home Cooking',
          'Catering': 'Catering',
          'Snacks': 'Snacks',
          'Cakes & Bakery': 'Cakes & Bakery',
          'Beverages': 'Beverages',
          'Healthy Food': 'Healthy Food',
          'Traditional Food': 'Traditional Food',
          'Frozen Food': 'Frozen Food',
          'Ingredients': 'Ingredients',
          'Other F&B': 'Other F&B',
          'Education & Books': 'Education & Books',
          'Textbooks': 'Textbooks',
          'Novels & Fiction': 'Novels & Fiction',
          'Non-Fiction Books': 'Non-Fiction Books',
          'Comics & Manga': 'Comics & Manga',
          'Children Books': 'Children Books',
          'Online Courses': 'Online Courses',
          'Stationery': 'Stationery',
          'Magazines': 'Magazines',
          'Imported Books': 'Imported Books',
          'E-Books & Audiobooks': 'E-Books & Audiobooks',
        }
      },
      id: {
        translation: {
          account_created: 'Akun berhasil dibuat. Silakan periksa email Anda untuk memverifikasi akun Anda.',
          account_verified: 'Akun berhasil diverifikasi. Anda sekarang dapat masuk.',
          registration_success: 'Pengguna berhasil didaftarkan. Silakan periksa email Anda untuk memverifikasi akun.',
          adDeleteError: 'Kesalahan saat menghapus iklan. Silakan coba lagi nanti.',
          adDeleted: 'Iklan berhasil dihapus.',
          adListEmpty: 'Tidak ada iklan ditemukan. Silakan periksa kembali nanti atau pasang iklan Anda sendiri.',
          adListError: 'Kesalahan saat mengambil iklan. Silakan coba lagi nanti.',
          adNotFound: 'Iklan tidak ditemukan.',
          adPostError: 'Kesalahan saat memasang iklan. Silakan coba lagi nanti.',
          adPosted: 'Iklan berhasil dipasang.',
          ads: 'Iklan',
          adUpdateError: 'Kesalahan saat memperbarui iklan. Silakan coba lagi nanti.',
          adUpdated: 'Iklan berhasil diperbarui.',
          category: 'Kategori',
          categoryListEmpty: 'Tidak ada kategori ditemukan. Silakan periksa kembali nanti.',
          // Product conditions
          condition: 'Kondisi',
          condition_new: 'Baru',
          condition_like_new: 'Seperti Baru',
          condition_good: 'Baik',
          condition_fair: 'Cukup',
          condition_poor: 'Buruk',
          categoryListError: 'Kesalahan saat mengambil kategori. Silakan coba lagi nanti.',
          categoryNotFound: 'Kategori tidak ditemukan.',
          changePassword: 'Ubah Kata Sandi',
          confirm_password: 'Konfirmasi Kata Sandi',
          contactDescription: 'Jika Anda memiliki pertanyaan atau membutuhkan bantuan, silakan isi formulir di bawah ini dan kami akan menghubungi Anda secepatnya.',
          contactEmail: 'Email Anda',
          contactError: 'Kesalahan saat mengirim pesan. Silakan coba lagi nanti.',
          contactForm: 'Formulir Kontak',
          contactMessage: 'Pesan Anda',
          contactName: 'Nama Anda',
          contactSend: 'Kirim Pesan',
          contactSuccess: 'Pesan Anda telah berhasil dikirim. Kami akan menghubungi Anda segera.',
          contactUs: 'Hubungi Kami',
          'Contact via WhatsApp': 'Hubungi via WhatsApp',
          create_in: 'Dibuat pada:',
          created_by: 'Dibuat oleh:',
          delete: 'Hapus',
          deleteAccount: 'Hapus Akun',
          deleteAccountConfirmation: 'Apakah Anda yakin ingin menghapus akun Anda? Tindakan ini tidak dapat dibatalkan.',
          deleteAccountError: 'Kesalahan saat menghapus akun. Silakan coba lagi nanti.',
          deleteAccountSuccess: 'Akun Anda telah berhasil dihapus.',
          deleteConfirm: 'Apakah Anda yakin ingin menghapus iklan ini? Tindakan ini tidak dapat dibatalkan.',
          deleteSuccess: 'Akun Anda telah berhasil dihapus.',
          description: 'Deskripsi',
          edit: 'Sunting',
          editProfile: 'Sunting Profil',
          email: 'E-mail',
          email_already_exists: 'Email sudah ada.',
          email_verification_error: 'Kesalahan saat mengirim tautan verifikasi email. Silakan coba lagi nanti.',
          email_verification_sent: 'Tautan verifikasi email telah dikirim. Silakan periksa kotak masuk Anda.',
          error: 'Terjadi kesalahan.',
          fill_all_required_fields: 'Harap isi semua bidang yang diperlukan termasuk kode pos.',
          homeDescription: 'Selamat datang di pasar kami! Di sini Anda dapat membeli, menjual, menyewa, dan berdagang dengan mudah. Nikmati menjelajahi iklan dan kategori terbaru yang dirancang untuk Anda.',
          image: 'Gambar',
          markAsSold: 'Tandai Terjual',
          markAsSoldConfirm: 'Apakah Anda yakin ingin menandai iklan ini sebagai terjual?',
          markAsSoldSuccess: 'Iklan berhasil ditandai sebagai terjual.',
          markAsSoldError: 'Kesalahan saat menandai iklan sebagai terjual.',
          reactivate: 'Aktifkan Kembali',
          reactivateConfirm: 'Apakah Anda yakin ingin mengaktifkan kembali iklan ini?',
          reactivateSuccess: 'Iklan berhasil diaktifkan kembali.',
          reactivateError: 'Kesalahan saat mengaktifkan kembali iklan.',
          sold: 'Terjual',
          statusActive: 'Aktif',
          statusInactive: 'Tidak Aktif',
          statusPending: 'Tertunda',
          statusSold: 'Terjual',
          statusDraft: 'Draf',
          statusRejected: 'Ditolak',
          imageRequired: 'Gambar wajib diisi.',
          imageUpload: 'Unggah Gambar',
          imageUploadDescription: 'Anda dapat mengunggah beberapa gambar. Gambar pertama akan menjadi gambar utama.',
          imageUploadError: 'Kesalahan saat mengunggah gambar. Silakan coba lagi nanti.',
          imageUploadSuccess: 'Gambar berhasil diunggah.',
          image_optimization_info: 'Gambar akan dioptimalkan secara otomatis menjadi kurang dari 200KB dalam format WebP',
          invalid_credentials: 'Kredensial tidak valid.',
          loading: 'Memuat...',
          location: 'Lokasi',
          location_hint: 'Klik pada peta untuk menandai lokasi perkiraan item Anda, atau gunakan tombol geolokasi untuk menggunakan lokasi Anda saat ini',
          location_title: 'Lokasi Barang',
          get_location: 'Dapatkan lokasi saya saat ini',
          use_current_location: 'Menggunakan lokasi Anda saat ini',
          getting_location: 'Mendapatkan lokasi...',
          postal_code: 'Kode Pos (Indonesia)',
          postal_code_placeholder: 'Contoh: 12190 (Jakarta)',
          search_location: 'Cari lokasi',
          searching: 'Mencari...',
          postal_code_help: 'Masukkan kode pos Indonesia 5 digit (contoh: 12190 untuk Jakarta, 40111 untuk Bandung) untuk menemukan lokasi secara otomatis di peta.',
          postal_code_required: 'Silakan masukkan kode pos',          postal_code_required_message: 'Kode pos diperlukan untuk mempublikasikan iklan',          postal_code_invalid_format: 'Kode pos harus tepat 5 digit angka',
          postal_code_invalid_range: 'Kode pos tidak valid untuk Indonesia',
          postal_code_not_found: 'Kode pos tidak ditemukan di Indonesia',
          postal_code_search_error: 'Kesalahan saat mencari kode pos',
          geolocation_error: 'Tidak dapat mengambil lokasi Anda',
          postal_code_found: 'Kode pos ditemukan',
          location_info_not_found: 'Informasi lokasi tidak tersedia',
          no_postal_code_found: 'Tidak ada kode pos untuk titik ini',
          loadingAd: 'Memuat iklan...',
          loadingAdError: 'Terjadi kesalahan saat memuat iklan. Silakan coba lagi nanti.',
          loadingAds: 'Memuat iklan...',
          loadingAdsError: 'Terjadi kesalahan saat memuat iklan. Silakan coba lagi nanti.',
          loadingCategories: 'Memuat kategori...',
          loadingCategoriesError: 'Terjadi kesalahan saat memuat kategori. Silakan coba lagi nanti.',
          loadingContactForm: 'Memuat formulir kontak...',
          loadingContactFormError: 'Terjadi kesalahan saat memuat formulir kontak. Silakan coba lagi nanti.',
          loadingError: 'Terjadi kesalahan saat memuat data. Silakan coba lagi nanti.',
          loadingPrivacy: 'Memuat kebijakan privasi...',
          loadingPrivacyError: 'Terjadi kesalahan saat memuat kebijakan privasi. Silakan coba lagi nanti.',
          loadingProfile: 'Memuat profil...',
          loadingProfileError: 'Terjadi kesalahan saat memuat profil. Silakan coba lagi nanti.',
          loadingTerms: 'Memuat syarat dan ketentuan...',
          loadingTermsError: 'Terjadi kesalahan saat memuat syarat dan ketentuan. Silakan coba lagi nanti.',
          logotipe: 'Beli, Sewa, Jual, Tukar, dan Lainnya',
          login: 'Masuk',
          email_or_phone: 'Email atau Telepon',
          email_or_phone_placeholder: 'Masukkan email atau nomor telepon Anda',
          logout: 'Keluar',
          myAccount: 'Akun Saya',
          myads: 'Iklan Saya',
          totalAds: 'Total Iklan',
          activeAds: 'Aktif',
          soldAds: 'Terjual',
          totalViews: 'Total Kunjungan',
          settings: 'Pengaturan',
          favorites: 'Favorit',
          messages: 'Pesan',
          statistics: 'Statistik',
          searchAds: 'Cari iklan...',
          sortNewest: 'Terbaru',
          sortOldest: 'Terlama',
          sortPriceHigh: 'Harga Tertinggi',
          sortPriceLow: 'Harga Terendah',
          sortViews: 'Paling Dilihat',
          all: 'Semua',
          gridView: 'Grid',
          listView: 'Daftar',
          noResults: 'Tidak ada hasil',
          tryDifferentSearch: 'Coba pencarian lain atau sesuaikan filter Anda',
          startPosting: 'Mulai pasang iklan',
          postFirstAd: 'Klik di sini untuk pasang iklan pertama Anda',
          noAdsMessage: 'Anda belum memasang iklan',
          name: 'Nama',
          optional: 'Opsional',
          negotiable_price: 'Harga Negosiasi',
          // Messages
          signin_required_message: 'Anda harus masuk untuk mengirim pesan',
          please_write_message: 'Silakan tulis pesan',
          message_sent_successfully: 'Pesan berhasil dikirim',
          error_sending_message: 'Kesalahan mengirim pesan',
          loading_messages: 'Memuat pesan...',
          no_messages_yet: 'Belum ada pesan',
          start_conversation: 'Mulai percakapan!',
          type_message: 'Ketik pesan...',
          seller: 'Penjual',
          Speak_with_seller: 'Hubungi Penjual',
          // Offers
          make_offer: 'Buat Penawaran',
          send_offer: 'Kirim Penawaran',
          offer_amount: 'Jumlah Penawaran',
          offer_message: 'Pesan (opsional)',
          offer_sent: 'Penawaran berhasil dikirim',
          offer_error: 'Kesalahan mengirim penawaran',
          enter_amount: 'Masukkan jumlah penawaran Anda',
          offer_too_low: 'Jumlah penawaran harus lebih besar dari 0',
          pending_offers: 'Penawaran Tertunda',
          no_offers_yet: 'Belum ada penawaran',
          accept_offer: 'Terima',
          reject_offer: 'Tolak',
          counter_offer: 'Tawar Balik',
          offer_accepted: 'Penawaran diterima!',
          offer_rejected: 'Penawaran ditolak',
          offer_countered: 'Tawaran balik dikirim',
          your_offer: 'Penawaran Anda:',
          seller_response: 'Respons penjual:',
          offer_sent_message: 'Saya telah mengirim penawaran sebesar Rp {{amount}}',
          // User type
          user_type: 'Tipe Pengguna',
          particular: 'Penjual Pribadi',
          professional: 'Profesional',
          select_user_type: 'Pilih tipe pengguna Anda',
          cancel: 'Batal',
          noAds: 'Sepertinya belum ada iklan yang dipasang...',
          notFound: 'Halaman Tidak Ditemukan',
          notFoundBackHome: 'Kembali ke Beranda',
          notFoundDescription: 'Halaman yang Anda cari tidak ada atau telah dipindahkan. Silakan periksa URL atau kembali ke beranda.',
          noResultsFound: 'Tidak ada hasil yang ditemukan untuk pencarian Anda.',
          passwrd: 'Kata Sandi',
          phone: 'Telepon Seluler',
          phone_examples: 'Contoh: +1 5551234567 (AS), +44 7911123456 (Inggris), +55 11999999999 (Brasil), +62 81234567890 (Indonesia)',
          phone_format_error: 'Harap masukkan nomor telepon internasional yang valid (contoh: +1 5551234567, +62 81234567890)',
          phone_placeholder: '+62 81234567890',
          passwordChanged: 'Kata sandi berhasil diubah.',
          passwordChangeError: 'Kesalahan saat mengubah kata sandi. Silakan coba lagi nanti.',
          password_confirmation: 'Konfirmasi Kata Sandi',
          password_reset: 'Kata sandi berhasil diatur ulang. Anda sekarang dapat masuk dengan kata sandi baru Anda.',
          password_reset_error: 'Kesalahan saat mengirim tautan reset kata sandi. Silakan coba lagi nanti.',
          password_reset_link_sent: 'Tautan reset kata sandi telah dikirim ke email Anda. Silakan periksa kotak masuk Anda.',
          postAd: 'Pasang Iklan +',
          postAdButton: 'Pasang Iklan',
          price: 'Harga',
          price_required: 'Harga diperlukan atau tandai sebagai dapat dinegosiasikan',
          priceNegotiable: 'Harga Bisa Nego',
          'Price Range': 'Rentang Harga',
          'Min': 'Min',
          'Max': 'Maks',
          'All': 'Semua',
          'Newest First': 'Terbaru Dulu',
          'Oldest First': 'Terlama Dulu',
          'Price: Low to High': 'Harga: Rendah ke Tinggi',
          'Price: High to Low': 'Harga: Tinggi ke Rendah',
          'Most Viewed': 'Paling Banyak Dilihat',
          'Results': 'Hasil',
          privacyDescription: 'Privasi Anda penting bagi kami. Silakan baca kebijakan privasi kami untuk memahami bagaimana kami mengumpulkan, menggunakan, dan melindungi informasi Anda.',
          privacyPolicy: 'Kebijakan Privasi',
          privacyPolicyLink: 'Kebijakan Privasi',
          profileUpdateError: 'Kesalahan saat memperbarui profil. Silakan coba lagi nanti.',
          profileUpdated: 'Profil berhasil diperbarui.',
          profileSettings: 'Pengaturan Profil',
          basicInformation: 'Informasi Dasar',
          updateBasicInfo: 'Perbarui informasi pribadi Anda',
          manageEmailSettings: 'Kelola email dan verifikasi Anda',
          managePhoneSettings: 'Kelola nomor telepon dan verifikasi Anda',
          updatePasswordSecurity: 'Ubah kata sandi untuk menjaga keamanan akun Anda',
          oauthLogin: 'Login OAuth',
          enterName: 'Masukkan nama Anda',
          enterState: 'Masukkan provinsi Anda',
          selectState: 'Pilih provinsi Anda',
          updateProfile: 'Perbarui Profil',
          emailAddress: 'Alamat Email',
          enterEmail: 'Masukkan email Anda',
          updateEmail: 'Perbarui Email',
          resendVerification: 'Kirim Ulang Verifikasi',
          emailVerificationRequired: 'Email verifikasi akan dikirim ke alamat email baru Anda',
          phoneNumber: 'Nomor Telepon',
          updatePhone: 'Perbarui Telepon',
          resendCode: 'Kirim Ulang Kode',
          verificationCode: 'Kode Verifikasi',
          verifyPhone: 'Verifikasi Telepon',
          phoneVerificationRequired: 'Kode verifikasi akan dikirim ke telepon Anda',
          phoneVerificationCodeSent: 'Kode verifikasi telah dikirim ke telepon Anda. Silakan masukkan kode 6 digit.',
          phoneVerificationSentTo: 'Kami mengirimkan kode verifikasi ke:',
          phoneVerifiedSuccess: 'Telepon berhasil diverifikasi! Mengalihkan ke halaman login...',
          verificationCodeResent: 'Kode verifikasi berhasil dikirim ulang.',
          enterVerificationCode: 'Silakan masukkan kode verifikasi 6 digit',
          didntReceiveCode: 'Tidak menerima kode?',
          verify: 'Verifikasi Kode',
          verifyNow: 'Verifikasi Sekarang',
          phoneVerifyModal: 'Verifikasi Telepon',
          phoneAlreadyInUse: 'Nomor telepon sudah digunakan',
          phoneAlreadyInUseMessage: 'Nomor telepon ini sudah terdaftar di akun lain. Silakan gunakan nomor yang berbeda.',
          codeSentSuccess: 'Kode verifikasi berhasil dikirim',
          codeSentError: 'Gagal mengirim kode verifikasi',
          codeVerifySuccess: 'Telepon berhasil diverifikasi',
          codeVerifyError: 'Kode verifikasi tidak valid atau kedaluwarsa',
          resendCodeIn: 'Kirim ulang kode dalam {{seconds}}d',
          resendCodeAvailable: 'Kirim Ulang Kode',
          enterCodePlaceholder: 'Masukkan kode 4 digit',
          codeExpiresWarning: 'Kode kedaluwarsa dalam 60 detik. Silakan masukkan dengan cepat.',
          currentPassword: 'Kata Sandi Saat Ini',
          enterCurrentPassword: 'Masukkan kata sandi saat ini',
          newPassword: 'Kata Sandi Baru',
          enterNewPassword: 'Masukkan kata sandi baru',
          confirmNewPassword: 'Konfirmasi kata sandi baru',
          oauthAccount: 'Anda masuk dengan {{provider}}. Perubahan kata sandi tidak tersedia.',
          verified: 'Terverifikasi',
          notVerified: 'Belum Terverifikasi',
          register: 'Daftar',
          registerDescription: 'Buat akun Anda untuk mulai memasang iklan dan menjelajahi marketplace kami. Isi formulir di bawah ini untuk memulai.',
          remember_me: 'Ingat saya',
          search: 'Cari di situs...',
          searchButton: 'Cari',
          seeAll: 'Lihat semua >>',
          sign_in: 'Masuk',
          sign_up: 'Daftar',
          phone_verification_required: 'Verifikasi Telepon Diperlukan',
          phone_verification_required_message: 'Akun Anda memerlukan verifikasi telepon sebelum Anda dapat masuk. Ini membantu kami menjaga keamanan platform dan mencegah spam.',
          verify_phone_now: 'Verifikasi Telepon Sekarang',
          speak_with_seller: 'Hubungi penjual',
          speak_with_seller_description: 'Jika Anda memiliki pertanyaan tentang iklan ini, Anda dapat menghubungi penjual langsung melalui email.',
          state: 'Provinsi',
          stateAll: 'Semua',
          termsAndConditions: 'Syarat dan Ketentuan',
          termsAndConditionsLink: 'Syarat dan Ketentuan',
          termsDescription: 'Silakan baca syarat dan ketentuan kami dengan seksama sebelum menggunakan marketplace kami. Dengan menggunakan situs kami, Anda setuju untuk mematuhi syarat ini.',
          title: 'Judul',
          token_invalid: 'Token tidak valid atau sudah kedaluwarsa.',
          token_not_provided: 'Token tidak diberikan.',
          user_not_found: 'Pengguna tidak ditemukan.',
          verifying: 'Memverifikasi...',
          emailVerified: 'Email berhasil diverifikasi. Anda sekarang dapat masuk.',
          view: 'Lihat',
          viewers: 'Kunjungan',
          viewAd: 'Lihat Iklan',
          contacts: 'kontak',
          must_login_favorites: 'Anda harus masuk untuk menambahkan favorit',
          must_login_messages: 'Anda harus masuk untuk mengirim pesan',
          interested_whatsapp: 'Halo, saya tertarik dengan iklan Anda:',
          welcome: 'Selamat datang di marketplace kami! Di sini Anda dapat membeli, menjual, menyewa, dan bertukar dengan mudah. Nikmati menjelajahi iklan dan kategori terbaru untuk Anda.',
          welcomeBack: 'Selamat datang kembali, {{name}}! Anda dapat mengelola iklan dan profil Anda di sini.',
          welcomeNewUser: 'Selamat datang! Silakan buat akun Anda untuk mulai memasang iklan dan menjelajahi marketplace kami.',
          welcomeTitle: 'Selamat Datang di Terserah! 🎉',
          welcomeText: 'Selamat datang di Terserah! Kami senang menyambut Anda di Terserah, ruang online baru Anda untuk menemukan berbagai produk dengan harga terbaik. Dari barang bekas berkualitas hingga peluang unik yang tidak ingin Anda lewatkan, Terserah adalah tempat ideal untuk membeli dan menjual dengan mudah, cepat, dan aman. Di platform kami, Anda dapat menjelajahi berbagai kategori: teknologi, fashion, rumah, olahraga, mainan, kendaraan, dan banyak lagi! Apakah Anda mencari sesuatu yang spesifik atau hanya sekadar melihat-lihat, kami yakin Anda akan menemukan sesuatu yang menarik. Jika Anda memiliki produk yang sudah tidak digunakan, unggah ke Terserah dan temukan orang yang membutuhkannya. Daur ulang, dapatkan uang, dan bantu planet ini pada saat yang sama! Terima kasih telah mempercayai kami. Mulai jelajahi sekarang dan temukan semua yang Terserah tawarkan untuk Anda.',
          whatareYouLookingFor: 'Apa yang Anda cari?',
          featuredAds: 'Iklan Unggulan ⭐',
          whatIsYourName: 'Siapa nama Anda?',
          // Categories
          'Electronics': 'Elektronik',
          'Smartphones': 'Smartphone',
          // Stats and How it Works
          'Active Ads': 'Iklan Aktif',
          'Categories': 'Kategori',
          '100% Free': '100% Gratis',
          'To Publish': 'Untuk Publikasi',
          'How It Works': 'Cara Kerja',
          'Search': 'Cari',
          'Browse thousands of ads in all categories': 'Jelajahi ribuan iklan di semua kategori',
          'Contact': 'Hubungi',
          'Message sellers directly to negotiate': 'Kirim pesan langsung ke penjual untuk bernegosiasi',
          'Deal': 'Transaksi',
          'Meet safely and complete your transaction': 'Bertemu dengan aman dan selesaikan transaksi Anda',
          'Recent Ads': 'Iklan Terbaru',
          'Computers and Laptops': 'Komputer dan Laptop',
          'Consoles and Videogames': 'Konsol dan Video Game',
          'Cameras and Photography': 'Kamera dan Fotografi',
          'Small Appliances': 'Peralatan Kecil',
          'Home and Furniture': 'Rumah dan Furnitur',
          'Furniture': 'Furnitur',
          'Decoration': 'Dekorasi',
          'Kitchen and Utensils': 'Dapur dan Peralatan',
          'Garden and Outdoor': 'Taman dan Outdoor',
          'Lighting': 'Pencahayaan',
          'Fashion and Accessories': 'Fashion dan Aksesori',
          'Clothing': 'Pakaian',
          'Footwear': 'Sepatu',
          'Bags and Backpacks': 'Tas dan Ransel',
          'Watches and Jewelry': 'Jam dan Perhiasan',
          'Accessories': 'Aksesori',
          'Motor': 'Motor',
          'Cars': 'Mobil',
          'Motorcycles': 'Sepeda Motor',
          'Vehicle Accessories': 'Aksesori Kendaraan',
          'Spare Parts': 'Suku Cadang',
          'Tools and Maintenance': 'Alat dan Perawatan',
          'Leisure, Sports and Others': 'Olahraga dan Lainnya',
          'Sports and Fitness': 'Olahraga dan Fitness',
          'Bicycles': 'Sepeda',
          'Musical Instruments': 'Alat Musik',
          'Toys and Games': 'Mainan dan Permainan',
          'Books and Collectibles': 'Buku dan Koleksi',
          // Services Category
          'Services': 'Sewa & Layanan',
          'Cleaning & Housekeeping': 'Pembersihan & Rumah Tangga',
          'Construction & Renovation': 'Konstruksi & Renovasi',
          'Education & Tutoring': 'Pendidikan & Les Privat',
          'Events & Catering': 'Acara & Katering',
          'Beauty & Wellness': 'Kecantikan & Kesehatan',
          'Technical Support & IT': 'Dukungan Teknis & IT',
          'Transportation & Delivery': 'Transportasi & Pengiriman',
          'Legal & Consulting': 'Hukum & Konsultasi',
          'Photography & Design': 'Fotografi & Desain',
          'Other Services': 'Layanan Lainnya',
          otherSellerAds: 'Penawaran lain dari penjual',
          
          // Common legal terms
          lastUpdated: 'Terakhir diperbarui',
          company: 'PT World Systems Consulting',
          platform: 'Terserah',
          country: 'Indonesia',
          
          // Privacy Policy
          privacy_title: 'Kebijakan Privasi',
          privacy_introduction_title: 'Pengantar',
          privacy_introduction_content: 'Kebijakan Privasi ini menjelaskan bagaimana Terserah ("kami," "kita," atau "milik kami") mengumpulkan, menggunakan, mengungkapkan, dan melindungi informasi pribadi pengguna ("Anda") yang mengakses dan menggunakan platform kami di https://terserah.id. Dengan menggunakan layanan kami, Anda menyetujui pengumpulan dan penggunaan informasi sesuai dengan kebijakan ini.',
          
          privacy_information_title: 'Informasi yang Kami Kumpulkan',
          privacy_information_intro: 'Kami mengumpulkan beberapa jenis informasi untuk menyediakan dan meningkatkan layanan kami kepada Anda:',
          privacy_information_personal: 'Informasi Pribadi:',
          privacy_information_personal_content: 'Nama, alamat email, nomor telepon, alamat, foto profil, dan informasi lain yang Anda berikan saat mendaftar akun atau mengirimkan iklan.',
          privacy_information_transactional: 'Informasi Transaksi:',
          privacy_information_transactional_content: 'Rincian transaksi yang Anda lakukan melalui platform kami, termasuk iklan yang Anda beli, jual, atau tawar.',
          privacy_information_technical: 'Informasi Teknis:',
          privacy_information_technical_content: 'Alamat IP, jenis browser, perangkat yang digunakan, sistem operasi, halaman yang dikunjungi, dan waktu akses.',
          privacy_information_usage: 'Data Penggunaan:',
          privacy_information_usage_content: 'Informasi tentang bagaimana Anda menggunakan platform kami, seperti pencarian yang dilakukan, iklan yang dilihat, dan interaksi dengan pengguna lain.',
          privacy_information_location: 'Data Lokasi:',
          privacy_information_location_content: 'Jika Anda mengizinkan, kami mengumpulkan informasi lokasi Anda untuk menampilkan iklan relevan berdasarkan lokasi geografis Anda.',
          privacy_user_provided: 'Informasi yang Anda Berikan',
          privacy_user_name: 'Nama lengkap',
          privacy_user_phone: 'Nomor telepon',
          privacy_user_email: 'Alamat email',
          privacy_user_photo: 'Foto profil',
          privacy_user_listings: 'Informasi listing (judul, deskripsi, harga, gambar)',
          privacy_auto_collected: 'Informasi yang Dikumpulkan Secara Otomatis',
          privacy_auto_ip: 'Alamat IP dan detail koneksi',
          privacy_auto_device: 'Jenis dan model perangkat',
          privacy_auto_browser: 'Jenis dan versi browser',
          privacy_auto_usage: 'Halaman yang dikunjungi dan pola penggunaan',
          
          privacy_purpose_title: 'Tujuan Penggunaan Informasi',
          privacy_purpose_intro: 'Kami menggunakan informasi yang dikumpulkan untuk:',
          privacy_purpose_platform: 'Menyediakan, mengoperasikan, dan memelihara platform kami.',
          privacy_purpose_personalize: 'Personalisasi pengalaman pengguna dengan menampilkan iklan yang relevan.',
          privacy_purpose_communicate: 'Berkomunikasi dengan Anda terkait layanan kami, termasuk pemberitahuan, pembaruan, dan dukungan pelanggan.',
          privacy_purpose_transactions: 'Memfasilitasi transaksi antara pengguna.',
          privacy_purpose_security: 'Memantau dan meningkatkan keamanan platform, termasuk deteksi dan pencegahan penipuan.',
          privacy_purpose_analytics: 'Menganalisis penggunaan platform untuk meningkatkan layanan kami.',
          privacy_purpose_legal: 'Mematuhi kewajiban hukum dan peraturan yang berlaku.',
          privacy_purpose_accounts: 'Membuat dan mengelola akun pengguna',
          privacy_purpose_display: 'Menampilkan iklan relevan berdasarkan lokasi dan preferensi',
          privacy_purpose_improve: 'Meningkatkan dan mengoptimalkan platform',
          privacy_purpose_prevent: 'Mencegah penipuan dan memastikan keamanan',
          privacy_purpose_comply: 'Mematuhi persyaratan hukum dan peraturan',
          
          privacy_legal_title: 'Dasar Hukum Pengolahan Data',
          privacy_legal_intro: 'Kami memproses data pribadi Anda berdasarkan dasar hukum berikut:',
          privacy_legal_contract: 'Pelaksanaan kontrak dengan Anda saat menggunakan layanan kami.',
          privacy_legal_interest: 'Kepentingan sah kami untuk mengoperasikan dan meningkatkan platform.',
          privacy_legal_consent: 'Persetujuan eksplisit Anda untuk pengumpulan dan pemrosesan data',
          privacy_legal_compliance: 'Kepatuhan terhadap kewajiban hukum.',
          privacy_legal_business: 'Kepentingan bisnis yang sah dalam meningkatkan layanan kami',
          
          privacy_sharing_title: 'Berbagi Informasi dengan Pihak Ketiga',
          privacy_sharing_intro: 'Kami tidak menjual informasi pribadi Anda. Namun, kami dapat membagikan informasi Anda dalam situasi berikut:',
          privacy_sharing_no_sell: 'Kami tidak menjual informasi pribadi Anda kepada pihak ketiga.',
          privacy_sharing_providers: 'Penyedia layanan yang membantu kami mengoperasikan platform (hosting, analitik)',
          privacy_sharing_providers_content: 'Kami dapat berbagi informasi dengan penyedia layanan yang membantu kami mengoperasikan platform, seperti penyedia hosting, layanan pembayaran, dan alat analitik.',
          privacy_sharing_authorities: 'Otoritas penegak hukum atau regulator saat diwajibkan oleh hukum',
          privacy_sharing_partners: 'Kami dapat membagikan data anonim dengan mitra untuk analitik dan tujuan peningkatan.',
          privacy_sharing_users: 'Pengguna Lain:',
          privacy_sharing_users_content: 'Informasi tertentu, seperti nama, email, dan nomor telepon, dapat terlihat oleh pengguna lain saat Anda memposting iklan atau menghubungi penjual.',
          privacy_sharing_legal: 'Kepatuhan Hukum:',
          privacy_sharing_legal_content: 'Kami dapat mengungkapkan informasi Anda jika diwajibkan oleh hukum atau untuk melindungi hak, properti, atau keselamatan kami, pengguna kami, atau pihak lain.',
          privacy_sharing_business: 'Transfer Bisnis:',
          privacy_sharing_business_content: 'Dalam hal merger, akuisisi, atau penjualan aset kami, informasi pengguna dapat ditransfer sebagai bagian dari transaksi tersebut.',
          
          privacy_storage_title: 'Penyimpanan dan Keamanan Data',
          privacy_storage_intro: 'Kami mengambil langkah-langkah yang wajar untuk melindungi informasi pribadi Anda dari akses, perubahan, pengungkapan, atau penghancuran yang tidak sah. Data kami disimpan di server yang aman, dan kami menerapkan enkripsi serta langkah-langkah keamanan lainnya untuk melindungi informasi Anda.',
          privacy_storage_https: 'Penggunaan enkripsi HTTPS untuk transmisi data',
          privacy_storage_servers: 'Server aman dengan akses terbatas',
          privacy_storage_access: 'Akses karyawan terbatas ke data pribadi berdasarkan kebutuhan',
          privacy_storage_warning: 'Namun, tidak ada metode transmisi melalui internet atau penyimpanan elektronik yang 100% aman. Meskipun kami berusaha menggunakan cara yang dapat diterima secara komersial untuk melindungi informasi pribadi Anda, kami tidak dapat menjamin keamanan mutlaknya.',
          
          privacy_retention_title: 'Retensi Data',
          privacy_retention_content: 'Kami menyimpan informasi pribadi Anda selama akun Anda aktif atau selama diperlukan untuk menyediakan layanan kami. Setelah Anda menghapus akun Anda, kami akan menghapus atau mengakar informasi pribadi Anda, kecuali jika diwajibkan oleh hukum untuk menyimpannya.',
          privacy_retention_intro: 'Kami menyimpan data Anda sesuai dengan prinsip berikut:',
          privacy_retention_active: 'Data akun aktif disimpan selama akun Anda aktif',
          privacy_retention_legal: 'Beberapa data dapat disimpan untuk mematuhi kewajiban hukum',
          privacy_retention_deletion: 'Anda dapat meminta penghapusan akun kapan saja melalui pengaturan akun Anda.',
          
          privacy_rights_title: 'Hak Anda',
          privacy_rights_intro: 'Anda memiliki hak berikut terkait informasi pribadi Anda:',
          privacy_rights_access: 'Akses:',
          privacy_rights_access_content: 'Anda dapat meminta salinan informasi pribadi yang kami simpan tentang Anda.',
          privacy_rights_correction: 'Koreksi:',
          privacy_rights_correction_content: 'Anda dapat meminta kami untuk memperbarui atau memperbaiki informasi pribadi Anda yang tidak akurat atau tidak lengkap.',
          privacy_rights_correct: 'Meminta koreksi data pribadi yang tidak akurat',
          privacy_rights_withdraw: 'Menarik persetujuan untuk pemrosesan data kapan saja',
          privacy_rights_delete: 'Meminta penghapusan data pribadi Anda',
          privacy_rights_complain: 'Mengajukan keluhan kepada otoritas perlindungan data',
          privacy_rights_deletion: 'Penghapusan:',
          privacy_rights_deletion_content: 'Anda dapat meminta kami untuk menghapus informasi pribadi Anda, dengan ketentuan tertentu.',
          privacy_rights_objection: 'Keberatan:',
          privacy_rights_objection_content: 'Anda dapat menolak pemrosesan informasi pribadi Anda dalam situasi tertentu.',
          privacy_rights_restriction: 'Pembatasan:',
          privacy_rights_restriction_content: 'Anda dapat meminta kami untuk membatasi pemrosesan informasi pribadi Anda.',
          privacy_rights_portability: 'Portabilitas Data:',
          privacy_rights_portability_content: 'Anda dapat meminta salinan data Anda dalam format yang dapat dibaca mesin.',
          privacy_rights_exercise: 'Untuk menggunakan hak-hak ini, silakan hubungi kami di',
          privacy_rights_contact: 'Untuk menggunakan hak-hak ini, silakan hubungi kami di info@terserah.id',
          
          privacy_cookies_title: 'Cookie dan Teknologi Pelacakan',
          privacy_cookies_content: 'Kami menggunakan cookie dan teknologi pelacakan serupa untuk meningkatkan pengalaman pengguna dan menganalisis lalu lintas situs web. Cookie adalah file kecil yang disimpan di perangkat Anda yang membantu kami mengenali Anda dan mengingat preferensi Anda. Anda dapat mengelola preferensi cookie Anda melalui pengaturan browser Anda, tetapi menonaktifkan cookie dapat mempengaruhi fungsionalitas platform kami.',
          privacy_cookies_intro: 'Kami menggunakan cookie dan teknologi serupa untuk:',
          privacy_cookies_experience: 'Meningkatkan pengalaman pengguna dan mengingat preferensi',
          privacy_cookies_analyze: 'Menganalisis lalu lintas dan pola penggunaan',
          privacy_cookies_security: 'Menjaga keamanan dan mencegah penipuan',
          privacy_cookies_disable: 'Anda dapat mengelola preferensi cookie di pengaturan browser Anda.',
          
          privacy_thirdparty_title: 'Tautan Pihak Ketiga',
          privacy_thirdparty_content: 'Platform kami dapat berisi tautan ke situs web pihak ketiga. Kami tidak bertanggung jawab atas praktik privasi atau konten situs web tersebut. Kami mendorong Anda untuk membaca kebijakan privasi dari setiap situs web yang Anda kunjungi.',
          
          privacy_changes_title: 'Perubahan pada Kebijakan Privasi ini',
          privacy_changes_content: 'Kami dapat memperbarui Kebijakan Privasi ini dari waktu ke waktu untuk mencerminkan perubahan pada praktik kami atau karena alasan operasional, hukum, atau peraturan lainnya. Kami akan memberi tahu Anda tentang perubahan apa pun dengan memposting Kebijakan Privasi yang baru di halaman ini dan memperbarui tanggal "Terakhir Diperbarui" di bagian atas.',
          
          privacy_contact_title: 'Hubungi Kami',
          privacy_contact_content: 'Jika Anda memiliki pertanyaan atau kekhawatiran tentang Kebijakan Privasi ini atau praktik privasi kami, silakan hubungi kami di:',
          privacy_contact_intro: 'Untuk pertanyaan tentang Kebijakan Privasi ini atau praktik privasi kami, silakan hubungi:',
          privacy_contact_email: 'Email: info@terserah.id',
          privacy_contact_address: 'Alamat: PT World Systems Consulting, Indonesia',
          
          // Terms and Conditions
          terms_title: 'Syarat dan Ketentuan',
          
          terms_acceptance_title: 'Penerimaan Syarat',
          terms_acceptance_content: 'Dengan mengakses atau menggunakan platform Terserah ("Platform"), Anda menyetujui untuk terikat oleh Syarat dan Ketentuan ini. Jika Anda tidak setuju dengan syarat ini, jangan gunakan Platform kami.',
          
          terms_service_title: 'Deskripsi Layanan',
          terms_service_content: 'Terserah adalah marketplace online yang memfasilitasi jual beli, sewa, dan pertukaran barang dan jasa antara pengguna di Indonesia. Platform ini tidak bertindak sebagai penjual atau pembeli, tetapi sebagai perantara yang menghubungkan pengguna.',
          terms_service_warning: 'Terserah tidak bertanggung jawab atas transaksi antara pengguna. Semua transaksi adalah tanggung jawab penuh pembeli dan penjual.',
          
          terms_eligibility_title: 'Kelayakan',
          terms_eligibility_content: 'Anda harus berusia minimal 18 tahun atau memiliki izin orang tua/wali untuk menggunakan Platform kami. Dengan mendaftar, Anda menjamin bahwa Anda memiliki kewenangan hukum untuk membuat perjanjian yang mengikat.',
          terms_eligibility_age: 'Berusia minimal 18 tahun atau memiliki persetujuan orang tua/wali.',
          terms_eligibility_accurate: 'Memberikan informasi yang akurat dan benar saat pendaftaran.',
          terms_eligibility_one_account: 'Hanya memiliki satu akun per orang.',
          
          terms_accounts_title: 'Akun Pengguna',
          terms_accounts_registration: 'Pendaftaran:',
          terms_accounts_registration_content: 'Anda harus membuat akun untuk mengakses beberapa fitur Platform. Anda bertanggung jawab untuk memberikan informasi yang akurat dan lengkap selama proses pendaftaran.',
          terms_accounts_security: 'Keamanan Akun:',
          terms_accounts_security_content: 'Anda bertanggung jawab untuk menjaga kerahasiaan kredensial akun Anda dan untuk semua aktivitas yang terjadi di bawah akun Anda. Laporkan segera kepada kami jika ada penggunaan yang tidak sah.',
          terms_accounts_termination: 'Penghentian Akun:',
          terms_accounts_termination_content: 'Kami berhak untuk menangguhkan atau mengakhiri akun Anda kapan saja jika Anda melanggar syarat ini atau terlibat dalam aktivitas yang ilegal atau tidak pantas.',
          terms_accounts_responsible: 'Anda bertanggung jawab atas semua aktivitas di bawah akun Anda.',
          terms_accounts_terminate: 'Kami berhak menangguhkan atau mengakhiri akun yang melanggar syarat kami.',
          terms_accounts_prohibited: 'Membuat beberapa akun atau berbagi kredensial akun dilarang.',
          
          terms_listings_title: 'Listing dan Konten',
          terms_listings_intro: 'Pengguna dilarang memposting iklan untuk barang-barang berikut:',
          terms_listings_illegal: 'Narkoba, narkotika, atau zat ilegal.',
          terms_listings_weapons: 'Senjata api, senjata, atau bahan peledak.',
          terms_listings_counterfeit: 'Produk palsu, bajakan, atau penipuan.',
          terms_listings_animals: 'Hewan yang dilindungi atau terancam punah tanpa izin yang tepat.',
          terms_listings_adult: 'Konten dewasa atau materi yang bersifat seksual eksplisit.',
          terms_listings_review: 'Kami berhak meninjau dan menghapus listing apa pun yang melanggar syarat ini.',
          terms_listings_responsibility: 'Tanggung Jawab Pengguna:',
          terms_listings_responsibility_content: 'Pengguna bertanggung jawab penuh atas konten yang mereka posting, termasuk iklan, gambar, deskripsi, dan informasi lainnya. Anda menjamin bahwa konten Anda tidak melanggar hak pihak ketiga atau hukum yang berlaku.',
          terms_listings_prohibited: 'Barang Terlarang:',
          terms_listings_prohibited_content: 'Anda tidak boleh memposting iklan untuk barang-barang yang dilarang oleh hukum Indonesia atau bertentangan dengan kebijakan kami, termasuk tetapi tidak terbatas pada: narkoba, senjata api, barang curian, produk palsu, atau konten yang menyinggung atau ilegal.',
          terms_listings_moderation: 'Moderasi Konten:',
          terms_listings_moderation_content: 'Kami berhak untuk meninjau, mengedit, atau menghapus konten apa pun yang melanggar syarat ini atau dianggap tidak pantas, tanpa pemberitahuan sebelumnya.',
          
          terms_transactions_title: 'Transaksi',
          terms_transactions_responsibility: 'Tanggung Jawab Pengguna:',
          terms_transactions_responsibility_content: 'Transaksi yang terjadi melalui Platform adalah antara pembeli dan penjual. Terserah tidak bertanggung jawab atas kualitas, keamanan, atau legalitas barang yang diperdagangkan, atau kemampuan penjual untuk menyelesaikan transaksi.',
          terms_transactions_disputes: 'Penyelesaian Sengketa:',
          terms_transactions_disputes_content: 'Pengguna bertanggung jawab untuk menyelesaikan sengketa yang mungkin timbul dari transaksi mereka. Kami dapat membantu memfasilitasi komunikasi, tetapi kami tidak bertanggung jawab untuk menengahi atau menyelesaikan perselisihan.',
          terms_transactions_between: 'Semua transaksi langsung antara pembeli dan penjual.',
          terms_transactions_no_guarantee: 'Terserah tidak menjamin kualitas, keamanan, atau legalitas barang yang terdaftar.',
          terms_transactions_risks: 'Pengguna menanggung semua risiko terkait transaksi dan harus berhati-hati.',
          
          terms_fees_title: 'Biaya',
          terms_fees_content: 'Penggunaan dasar Platform gratis. Namun, kami dapat membebankan biaya untuk layanan premium atau fitur tambahan di masa mendatang. Perubahan biaya akan diumumkan di Platform.',
          terms_fees_current: 'Saat ini, memposting dan menjelajahi iklan di Terserah sepenuhnya gratis.',
          terms_fees_future: 'Kami berhak memperkenalkan biaya untuk fitur premium di masa mendatang, dengan pemberitahuan terlebih dahulu kepada pengguna.',
          
          terms_conduct_title: 'Perilaku Pengguna',
          terms_conduct_intro: 'Saat menggunakan Platform, Anda setuju untuk tidak:',
          terms_conduct_laws: 'Melanggar hukum atau peraturan yang berlaku.',
          terms_conduct_fraud: 'Terlibat dalam aktivitas penipuan, menyesatkan, atau menipu.',
          terms_conduct_harass: 'Melecehkan, mengancam, memfitnah, atau menyalahgunakan pengguna lain.',
          terms_conduct_manipulate: 'Mencoba memanipulasi harga, ulasan, atau peringkat pencarian.',
          terms_conduct_circumvent: 'Menghindari atau mengganggu fitur keamanan Platform.',
          terms_conduct_others: 'Melecehkan, mengancam, atau menyalahgunakan pengguna lain.',
          terms_conduct_interfere: 'Mengganggu atau merusak fungsionalitas Platform.',
          terms_conduct_bots: 'Menggunakan bot, scraper, atau alat otomatis lainnya tanpa izin kami.',
          terms_conduct_impersonate: 'Menyamar sebagai orang lain atau entitas.',
          
          terms_ip_title: 'Kekayaan Intelektual',
          terms_ip_content: 'Semua konten, logo, merek dagang, dan materi lainnya di Platform adalah milik PT World Systems Consulting atau pemberi lisensinya dan dilindungi oleh hukum kekayaan intelektual. Anda tidak boleh menggunakan, mereproduksi, atau mendistribusikan konten kami tanpa izin tertulis.',
          
          terms_liability_title: 'Pembatasan Tanggung Jawab',
          terms_liability_intro: 'Sejauh yang diizinkan oleh hukum:',
          terms_liability_asis: 'Terserah menyediakan Platform "sebagaimana adanya" tanpa jaminan apa pun, baik tersurat maupun tersirat.',
          terms_liability_nodamages: 'Kami tidak bertanggung jawab atas kerugian langsung, tidak langsung, insidental, atau konsekuensial yang timbul dari penggunaan atau ketidakmampuan untuk menggunakan Platform.',
          terms_liability_noliability: 'Kami tidak bertanggung jawab atas tindakan atau kelalaian pengguna, atau atas transaksi yang dilakukan melalui Platform.',
          terms_liability_not_liable: 'Terserah tidak bertanggung jawab atas kerugian, kerusakan, atau perselisihan yang timbul dari transaksi pengguna.',
          terms_liability_not_responsible: 'Kami tidak bertanggung jawab atas keakuratan, kualitas, atau legalitas konten yang diposting pengguna.',
          
          terms_privacy_title: 'Privasi',
          terms_privacy_content: 'Penggunaan informasi pribadi Anda diatur oleh Kebijakan Privasi kami, yang merupakan bagian dari Syarat dan Ketentuan ini. Silakan baca Kebijakan Privasi untuk memahami bagaimana kami mengumpulkan, menggunakan, dan melindungi data Anda.',
          
          terms_termination_title: 'Penghentian',
          terms_termination_content: 'Kami berhak untuk menangguhkan atau mengakhiri akses Anda ke Platform kapan saja, dengan atau tanpa sebab, dan tanpa pemberitahuan sebelumnya. Setelah penghentian, Anda harus berhenti menggunakan Platform, dan semua hak yang diberikan kepada Anda berdasarkan syarat ini akan berakhir.',
          
          terms_law_title: 'Hukum yang Mengatur',
          terms_law_content: 'Syarat dan Ketentuan ini diatur oleh dan ditafsirkan sesuai dengan hukum Indonesia. Setiap sengketa yang timbul dari atau terkait dengan syarat ini akan diselesaikan di pengadilan Indonesia.',
          terms_governing_title: 'Hukum yang Mengatur',
          terms_governing_content: 'Syarat dan Ketentuan ini diatur oleh dan ditafsirkan sesuai dengan hukum Indonesia. Setiap sengketa akan diselesaikan di pengadilan Indonesia.',
          
          terms_contact_title: 'Hubungi Kami',
          terms_contact_content: 'Jika Anda memiliki pertanyaan tentang Syarat dan Ketentuan ini, silakan hubungi kami di:',
          terms_contact_intro: 'Jika Anda memiliki pertanyaan atau kekhawatiran tentang Syarat dan Ketentuan ini, silakan hubungi kami:',
          terms_contact_email: 'Email: info@terserah.id',
          terms_contact_address: 'Alamat: PT World Systems Consulting, Indonesia',

          // Notifications
          notifications_title: 'Notifikasi',
          notifications_none: 'Tidak ada notifikasi',
          notifications_mark_read: 'Tandai sudah dibaca',
          notifications_mark_all_read: 'Tandai semua sudah dibaca',
          notifications_delete: 'Hapus',
          notifications_new: 'Notifikasi baru',
          notification_message: 'mengirim pesan kepada Anda',
          notification_offer_received: 'mengirim tawaran kepada Anda',
          notification_offer_accepted: 'menerima tawaran Anda',
          notification_offer_rejected: 'menolak tawaran Anda',
          notification_offer_countered: 'melakukan counter tawaran Anda',
          notification_review_received: 'memberi Anda ulasan',
          notification_ad_sold: 'Iklan Anda telah ditandai sebagai terjual',
          notification_ad_expired: 'Iklan Anda telah kedaluwarsa',
          notification_price_drop: 'Penurunan harga pada iklan yang Anda simpan',
          notification_saved_search_match: 'Iklan baru cocok dengan pencarian tersimpan Anda',
          notification_follow_new_ad: 'memposting iklan baru',

          // Offers
          offers_title: 'Tawaran',
          offers_none: 'Belum ada tawaran',
          offers_received: 'Tawaran Diterima',
          offers_sent: 'Tawaran Dikirim',
          offers_make: 'Buat Tawaran',
          offers_accept: 'Terima',
          offers_reject: 'Tolak',
          offers_counter: 'Tawaran Balasan',
          offers_pending: 'Menunggu',
          offers_accepted: 'Diterima',
          offers_rejected: 'Ditolak',
          offers_countered: 'Di-counter',
          offers_expired: 'Kedaluwarsa',
          offers_amount: 'Jumlah Tawaran',
          offers_message: 'Pesan',
          offers_expires: 'Kedaluwarsa dalam',
          offers_expired_on: 'Kedaluwarsa pada',
          offers_status: 'Status',

          // Verification Badges
          verification_elite: 'Penjual Elite',
          verification_pro: 'Penjual Pro',
          verification_trusted: 'Penjual Terpercaya',
          verification_verified: 'Pengguna Terverifikasi',
          verification_new: 'Pengguna Baru',
          verification_level: 'Tingkat Verifikasi',

          // Biography
          biography: 'Biografi',
          biographyPlaceholder: 'Ceritakan tentang diri Anda...',
          characters: 'karakter',
          
          // Reviews
          reviews: 'ulasan',
          review: 'ulasan',
          leave_review: 'Berikan ulasan',
          leave_review_title: 'Berikan ulasan',
          review_rating_label: 'Penilaian *',
          review_comment_label: 'Komentar (opsional)',
          review_comment_placeholder: 'Bagikan pengalaman Anda dengan pengguna ini...',
          review_submit: 'Kirim ulasan',
          review_submitting: 'Mengirim...',
          review_success: 'Ulasan berhasil dikirim',
          review_error: 'Kesalahan mengirim ulasan',
          review_rating_required: 'Silakan pilih penilaian',
          review_rating_very_bad: 'Sangat buruk',
          review_rating_bad: 'Buruk',
          review_rating_average: 'Rata-rata',
          review_rating_good: 'Baik',
          review_rating_excellent: 'Sangat baik',
          reviews_title: 'Ulasan ({{count}})',
          reviews_loading: 'Memuat ulasan...',
          reviews_empty: 'Pengguna ini belum memiliki ulasan',
          reviews_load_more: 'Muat lebih banyak ulasan',
          reviews_ad_reference: '📦 Iklan: {{title}}',
          reviews_user_label: 'Pengguna',
          reviews_today: 'Hari ini',
          reviews_yesterday: 'Kemarin',
          reviews_days_ago: '{{days}} hari yang lalu',
          reviews_weeks_ago: '{{weeks}} minggu yang lalu',
          reviews_months_ago: '{{months}} bulan yang lalu',
          reviews_years_ago: '{{years}} tahun yang lalu',
          
          // Social Share
          share: 'Bagikan',
          share_title_default: 'Lihat iklan ini di Terserah',
          share_description_default: 'Saya menemukan iklan menarik ini di Terserah',
          share_link_copied: 'Tersalin!',
          share_copy_link: 'Salin tautan',
          
          // Report Ad
          report_ad: '🚩 Laporkan iklan',
          report_ad_title: 'Laporkan iklan',
          report_ad_subtitle: 'Bantu kami menjaga keamanan komunitas dengan melaporkan konten yang tidak pantas',
          report_ad_reason_label: 'Apa alasan pelaporan?',
          report_ad_reason_spam: '📢 Spam atau konten berulang',
          report_ad_reason_inappropriate: '🚫 Konten tidak pantas atau menyinggung',
          report_ad_reason_fraud: '⚠️ Kemungkinan penipuan atau scam',
          report_ad_reason_duplicate: '📋 Iklan duplikat',
          report_ad_reason_other: '❓ Alasan lain',
          report_ad_details_label: 'Detail tambahan (opsional)',
          report_ad_details_placeholder: 'Berikan informasi lebih lanjut tentang masalah ini...',
          report_ad_cancel: 'Batal',
          report_ad_submit: 'Kirim Laporan',
          report_ad_submitting: 'Mengirim...',
          report_ad_success: 'Laporan berhasil dikirim. Tim kami akan meninjaunya segera.',
          report_ad_error: 'Kesalahan mengirim laporan',
          report_ad_reason_required: 'Silakan pilih alasan',
          report_ad_login_required: 'Anda harus masuk untuk melaporkan iklan',

          // Follow System
          follow: 'Ikuti',
          following: 'Mengikuti',
          unfollow: 'Berhenti Mengikuti',
          followers: 'Pengikut',
          followersCount: '{{count}} pengikut',
          followingCount: '{{count}} mengikuti',
          followingFeed: 'Feed Mengikuti',
          noFollowing: 'Belum mengikuti siapa pun',
          startFollowing: 'Ikuti pengguna untuk melihat iklan mereka di sini',
          
          // User Profile
          user_profile: 'Profil Pengguna',
          user_profile_description: 'Lihat informasi dan statistik profil pengguna',
          error_loading_profile: 'Kesalahan memuat profil',
          bio_placeholder: 'Ceritakan tentang diri Anda...',
          edit_bio: 'Edit Bio',
          save_bio: 'Simpan',
          bio_max_length: 'Bio harus kurang dari 500 karakter',
          error_saving_bio: 'Kesalahan menyimpan bio',
          no_bio_yet: 'Tambahkan bio untuk memberi tahu orang tentang Anda',
          no_bio: 'Pengguna ini belum menambahkan bio',
          member_since: 'Anggota sejak',
          
          // App Download
          download_android_app: 'Unduh Aplikasi Android',
          download_ios_app: 'Unduh Aplikasi iOS',
          get_it_on: 'DAPATKAN DI',
          download_on: 'Unduh di',
          
          // Search
          searchPlaceholder: 'Cari produk...',
          suggestions: 'Saran',
          recentSearches: 'Pencarian Terakhir',
          popularSearches: 'Pencarian Populer',
          relatedSearches: 'Pencarian Terkait',
          clearHistory: 'Hapus Riwayat',
          noRecentSearches: 'Tidak ada pencarian terakhir',
          results: 'hasil',
          
          // Empty States
          'No data available': 'Tidak ada data tersedia',
          'There is no content to display at the moment': 'Tidak ada konten untuk ditampilkan saat ini',
          'Try adjusting your filters or search terms': 'Coba sesuaikan filter atau kata pencarian Anda',
          'Start a conversation by contacting a seller': 'Mulai percakapan dengan menghubungi penjual',
          'Browse ads': 'Jelajahi iklan',
          'Save ads you like to find them easily later': 'Simpan iklan yang Anda suka untuk menemukannya dengan mudah nanti',
          'Explore ads': 'Jelajahi iklan',
          'We\'ll notify you when something happens': 'Kami akan memberi tahu Anda ketika sesuatu terjadi',
          'Try different keywords or remove some filters': 'Coba kata kunci yang berbeda atau hapus beberapa filter',
          'Clear filters': 'Hapus filter',
          'Follow users to see their ads in your personalized feed': 'Ikuti pengguna untuk melihat iklan mereka di feed Anda',
          'Find users': 'Temukan pengguna',
          'Buyers can make offers on your negotiable items': 'Pembeli dapat membuat penawaran pada item yang dapat dinegosiasikan',
          'Something went wrong': 'Terjadi kesalahan',
          'Please try again later or contact support': 'Silakan coba lagi nanti atau hubungi dukungan',
          'Retry': 'Coba lagi',
          
          // Terms acceptance messages
          agree_terms_privacy: 'Saya setuju dengan Syarat & Ketentuan dan Kebijakan Privasi',
          by_posting_agree_terms: 'Dengan memposting iklan, Anda menyetujui',
          terms_and: 'Syarat & Ketentuan',
          
          // Category translations
          'Vehicles': 'Kendaraan',
          'Trucks': 'Truk',
          'Buses': 'Bus',
          'Boats': 'Perahu',
          'Vehicle Parts': 'Suku Cadang',
          'Vehicle Services': 'Layanan Kendaraan',
          'Heavy Machinery': 'Alat Berat',
          'Other Vehicles': 'Kendaraan Lainnya',
          'Property': 'Properti',
          'Houses': 'Rumah',
          'Apartments': 'Apartemen',
          'Land': 'Tanah',
          'Commercial Property': 'Properti Komersial',
          'Villas': 'Vila',
          'Boarding Houses': 'Kos-Kosan',
          'Offices': 'Kantor',
          'Warehouses': 'Gudang',
          'Shops': 'Toko/Ruko',
          'Other Property': 'Properti Lainnya',
          'Phones & Tablets': 'HP & Tablet',
          'Computers & Laptops': 'Komputer & Laptop',
          'TVs & Audio': 'TV & Audio',
          'Cameras': 'Kamera',
          'Gaming': 'Gaming',
          'Smart Home': 'Smart Home',
          'Wearables': 'Perangkat Wearable',
          'Drones': 'Drone',
          'Other Electronics': 'Elektronik Lainnya',
          'Fashion & Beauty': 'Fashion & Kecantikan',
          'Mens Fashion': 'Fashion Pria',
          'Womens Fashion': 'Fashion Wanita',
          'Kids Fashion': 'Fashion Anak',
          'Bags & Luggage': 'Tas & Koper',
          'Shoes': 'Sepatu',
          'Watches': 'Jam Tangan',
          'Jewelry': 'Perhiasan',
          'Beauty Products': 'Produk Kecantikan',
          'Skincare': 'Perawatan Kulit',
          'Other Fashion': 'Fashion Lainnya',
          'Hobbies & Sports': 'Hobi & Olahraga',
          'Sports Equipment': 'Alat Olahraga',
          'Art & Crafts': 'Seni & Kerajinan',
          'Collectibles': 'Koleksi',
          'Outdoor Gear': 'Perlengkapan Outdoor',
          'Fishing': 'Pancing',
          'Cycling': 'Sepeda',
          'Gym & Fitness': 'Gym & Fitness',
          'Board Games': 'Board Game',
          'Other Hobbies': 'Hobi Lainnya',
          'Home & Living': 'Rumah & Kehidupan',
          'Home Appliances': 'Elektronik Rumah',
          'Kitchen & Dining': 'Dapur & Makan',
          'Bedding': 'Perlengkapan Tidur',
          'Home Decor': 'Dekorasi Rumah',
          'Garden & Outdoor': 'Taman & Outdoor',
          'Tools & DIY': 'Alat & DIY',
          'Bathroom': 'Kamar Mandi',
          'Other Home': 'Rumah Lainnya',
          'Home Services': 'Jasa Rumah',
          'Repair Services': 'Jasa Perbaikan',
          'Construction': 'Konstruksi',
          'Moving Services': 'Jasa Pindahan',
          'Cleaning Services': 'Jasa Kebersihan',
          'Beauty Services': 'Jasa Kecantikan',
          'Event Services': 'Jasa Event',
          'Photography': 'Fotografi',
          'Legal Services': 'Jasa Hukum',
          'Jobs': 'Lowongan Kerja',
          'Full Time Jobs': 'Full Time',
          'Part Time Jobs': 'Part Time',
          'Freelance': 'Freelance',
          'Internships': 'Magang',
          'Remote Work': 'Kerja Remote',
          'IT & Software': 'IT & Software',
          'Sales & Marketing': 'Sales & Marketing',
          'Hospitality': 'Perhotelan',
          'Education': 'Pendidikan',
          'Other Jobs': 'Pekerjaan Lainnya',
          'Food & Beverages': 'Makanan & Minuman',
          'Home Cooking': 'Masakan Rumah',
          'Catering': 'Katering',
          'Snacks': 'Camilan',
          'Cakes & Bakery': 'Kue & Roti',
          'Beverages': 'Minuman',
          'Healthy Food': 'Makanan Sehat',
          'Traditional Food': 'Makanan Tradisional',
          'Frozen Food': 'Frozen Food',
          'Ingredients': 'Bahan Makanan',
          'Other F&B': 'F&B Lainnya',
          'Education & Books': 'Pendidikan & Buku',
          'Textbooks': 'Buku Pelajaran',
          'Novels & Fiction': 'Novel & Fiksi',
          'Non-Fiction Books': 'Buku Non-Fiksi',
          'Comics & Manga': 'Komik & Manga',
          'Children Books': 'Buku Anak-Anak',
          'Online Courses': 'Kursus Online',
          'Stationery': 'Alat Tulis',
          'Magazines': 'Majalah & Tabloid',
          'Imported Books': 'Buku Import',
          'E-Books & Audiobooks': 'E-Book & Audiobook',
        }
      },
      es: {
        translation: {
          account_created: 'Cuenta creada exitosamente. Por favor revisa tu correo para verificar tu cuenta.',
          account_verified: 'Cuenta verificada exitosamente. Ahora puedes iniciar sesión.',
          registration_success: 'Usuario registrado exitosamente. Por favor revisa tu correo para verificar la cuenta.',
          adDeleteError: 'Error al eliminar el anuncio. Por favor, inténtalo de nuevo más tarde.',
          adDeleted: 'Anuncio eliminado exitosamente.',
          adListEmpty: 'No se encontraron anuncios. Por favor, vuelve más tarde o publica tu propio anuncio.',
          adListError: 'Error al obtener los anuncios. Por favor, inténtalo de nuevo más tarde.',
          adNotFound: 'Anuncio no encontrado.',
          adPostError: 'Error al publicar el anuncio. Por favor, inténtalo de nuevo más tarde.',
          adPosted: 'Anuncio publicado exitosamente.',
          adUpdateError: 'Error al actualizar el anuncio. Por favor, inténtalo de nuevo más tarde.',
          adUpdated: 'Anuncio actualizado exitosamente.',
          ads: 'Anuncios',
          category: 'Categoría',
          categoryListEmpty: 'No se encontraron categorías. Por favor, vuelve más tarde.',
          // Product conditions
          condition: 'Condición',
          condition_new: 'Nuevo',
          condition_like_new: 'Como Nuevo',
          condition_good: 'Buen Estado',
          condition_fair: 'Estado Regular',
          condition_poor: 'Estado Pobre',
          categoryListError: 'Error al obtener las categorías. Por favor, inténtalo de nuevo más tarde.',
          categoryNotFound: 'Categoría no encontrada.',
          changePassword: 'Cambiar Contraseña',
          confirm_password: 'Confirmar Contraseña',
          contactDescription: 'Si tienes alguna pregunta o necesitas ayuda, por favor completa el formulario a continuación y nos pondremos en contacto contigo lo antes posible.',
          contactEmail: 'Tu Correo',
          contactError: 'Error al enviar el mensaje. Por favor, inténtalo de nuevo más tarde.',
          contactForm: 'Formulario de Contacto',
          contactMessage: 'Tu Mensaje',
          contactName: 'Tu Nombre',
          contactSend: 'Enviar Mensaje',
          contactSuccess: 'Tu mensaje ha sido enviado exitosamente. Nos pondremos en contacto contigo pronto.',
          contactUs: 'Contáctanos',          'Contact via WhatsApp': 'Contactar por WhatsApp',          create_in: 'Creado en:',
          created_by: 'Creado por:',
          delete: 'Eliminar',
          deleteAccount: 'Eliminar Cuenta',
          deleteAccountConfirmation: '¿Estás seguro de que deseas eliminar tu cuenta? Esta acción no se puede deshacer.',
          deleteAccountError: 'Error al eliminar la cuenta. Por favor, inténtalo de nuevo más tarde.',
          deleteAccountSuccess: 'Tu cuenta ha sido eliminada exitosamente.',
          deleteConfirm: '¿Estás seguro de que quieres eliminar este anuncio? Esta acción no se puede deshacer.',
          deleteSuccess: 'Tu cuenta ha sido eliminada exitosamente.',
          description: 'Descripción',
          edit: 'Editar',
          editProfile: 'Editar Perfil',
          email: 'Correo electrónico',
          email_already_exists: 'El correo electrónico ya existe.',
          email_verification_error: 'Error al enviar el enlace de verificación de correo. Por favor, inténtalo de nuevo más tarde.',
          email_verification_sent: 'Enlace de verificación de correo enviado. Por favor, revisa tu bandeja de entrada.',
          error: 'Ocurrió un error.',
          fill_all_required_fields: 'Por favor, completa todos los campos obligatorios incluyendo el código postal.',
          homeDescription: '¡Bienvenido a nuestro mercado! Aquí puedes comprar, vender, alquilar e intercambiar fácilmente. Disfruta explorando los últimos anuncios y categorías diseñadas para ti.',
          image: 'Imagen',
          markAsSold: 'Marcar como Vendido',
          markAsSoldConfirm: '¿Estás seguro de que quieres marcar este anuncio como vendido?',
          markAsSoldSuccess: 'Anuncio marcado como vendido exitosamente.',
          markAsSoldError: 'Error al marcar el anuncio como vendido.',
          reactivate: 'Reactivar',
          reactivateConfirm: '¿Estás seguro de que quieres reactivar este anuncio?',
          reactivateSuccess: 'Anuncio reactivado exitosamente.',
          reactivateError: 'Error al reactivar el anuncio.',
          sold: 'Vendido',
          statusActive: 'Activo',
          statusInactive: 'Inactivo',
          statusPending: 'Pendiente',
          statusSold: 'Vendido',
          statusDraft: 'Borrador',
          statusRejected: 'Rechazado',
          imageRequired: 'La imagen es obligatoria.',
          imageUpload: 'Subir Imagen',
          imageUploadDescription: 'Puedes subir varias imágenes. La primera será la principal.',
          imageUploadError: 'Error al subir la imagen. Por favor, inténtalo de nuevo más tarde.',
          imageUploadSuccess: 'Imagen subida exitosamente.',
          invalid_credentials: 'Credenciales inválidas.',
          loading: 'Cargando...',
          location: 'Ubicación',
          location_hint: 'Haz clic en el mapa para marcar la ubicación aproximada de tu artículo, o usa el botón de geolocalización para usar tu ubicación actual',
          location_title: 'Ubicación del Artículo',
          get_location: 'Obtener mi ubicación actual',
          use_current_location: 'Usando tu ubicación actual',
          getting_location: 'Obteniendo ubicación...',
          postal_code: 'Código Postal (Indonesia)',
          postal_code_placeholder: 'Ej: 12190 (Jakarta)',
          search_location: 'Buscar ubicación',
          searching: 'Buscando...',
          postal_code_help: 'Ingresa un código postal indonesio de 5 dígitos (ej: 12190 para Jakarta, 40111 para Bandung) para ubicar automáticamente en el mapa.',
          postal_code_required: 'Por favor ingresa un código postal',          postal_code_required_message: 'El código postal es obligatorio para publicar el anuncio',          postal_code_invalid_format: 'El código postal debe tener exactamente 5 dígitos numéricos',
          postal_code_invalid_range: 'Código postal no válido para Indonesia',
          postal_code_not_found: 'Código postal no encontrado en Indonesia',
          postal_code_search_error: 'Error al buscar código postal',
          geolocation_error: 'No se pudo obtener tu ubicación',
          postal_code_found: 'Código postal encontrado',
          location_info_not_found: 'Información de ubicación no disponible',
          no_postal_code_found: 'No se encontró código postal para este punto',
          loadingAd: 'Cargando anuncio...',
          loadingAdError: 'Error al cargar el anuncio. Por favor, inténtalo de nuevo más tarde.',
          loadingAds: 'Cargando anuncios...',
          loadingAdsError: 'Error al cargar los anuncios. Por favor, inténtalo de nuevo más tarde.',
          loadingCategories: 'Cargando categorías...',
          loadingCategoriesError: 'Error al cargar las categorías. Por favor, inténtalo de nuevo más tarde.',
          loadingContactForm: 'Cargando formulario de contacto...',
          loadingContactFormError: 'Error al cargar el formulario de contacto. Por favor, inténtalo de nuevo más tarde.',
          loadingError: 'Error al cargar los datos. Por favor, inténtalo de nuevo más tarde.',
          loadingPrivacy: 'Cargando política de privacidad...',
          loadingPrivacyError: 'Error al cargar la política de privacidad. Por favor, inténtalo de nuevo más tarde.',
          loadingProfile: 'Cargando perfil...',
          loadingProfileError: 'Error al cargar el perfil. Por favor, inténtalo de nuevo más tarde.',
          loadingTerms: 'Cargando términos y condiciones...',
          loadingTermsError: 'Error al cargar los términos y condiciones. Por favor, inténtalo de nuevo más tarde.',
          logotipe: 'Compra, Alquila, Vende, Intercambia y Más',
          login: 'Iniciar sesión',
          email_or_phone: 'Email o Teléfono',
          email_or_phone_placeholder: 'Ingresa tu email o número de teléfono',
          logout: 'Cerrar sesión',
          myAccount: 'Mi Cuenta',
          myads: 'Mis Anuncios',
          totalAds: 'Total de Anuncios',
          activeAds: 'Activos',
          soldAds: 'Vendidos',
          totalViews: 'Total de Visitas',
          settings: 'Configuración',
          favorites: 'Favoritos',
          messages: 'Mensajes',
          statistics: 'Estadísticas',
          searchAds: 'Buscar anuncios...',
          sortNewest: 'Más Recientes',
          sortOldest: 'Más Antiguos',
          sortPriceHigh: 'Precio Más Alto',
          sortPriceLow: 'Precio Más Bajo',
          sortViews: 'Más Vistos',
          all: 'Todos',
          gridView: 'Cuadrícula',
          listView: 'Lista',
          noResults: 'No se encontraron resultados',
          tryDifferentSearch: 'Intenta con otra búsqueda o ajusta tus filtros',
          startPosting: 'Comienza a publicar anuncios',
          postFirstAd: 'Haz clic aquí para publicar tu primer anuncio',
          noAdsMessage: 'Aún no has publicado ningún anuncio',
          name: 'Nombre',
          optional: 'Opcional',
          negotiable_price: 'Precio Negociable',
          // Messages
          signin_required_message: 'Debes iniciar sesión para enviar mensajes',
          please_write_message: 'Por favor escribe un mensaje',
          message_sent_successfully: 'Mensaje enviado exitosamente',
          error_sending_message: 'Error al enviar mensaje',
          loading_messages: 'Cargando mensajes...',
          no_messages_yet: 'No hay mensajes aún',
          start_conversation: '¡Inicia la conversación!',
          type_message: 'Escribe un mensaje...',
          seller: 'Vendedor',
          Speak_with_seller: 'Contactar Vendedor',
          // Offers
          make_offer: 'Hacer Oferta',
          send_offer: 'Enviar Oferta',
          offer_amount: 'Monto de Oferta',
          offer_message: 'Mensaje (opcional)',
          offer_sent: 'Oferta enviada exitosamente',
          offer_error: 'Error al enviar oferta',
          enter_amount: 'Ingresa el monto de tu oferta',
          offer_too_low: 'El monto de oferta debe ser mayor que 0',
          pending_offers: 'Ofertas Pendientes',
          no_offers_yet: 'No hay ofertas aún',
          accept_offer: 'Aceptar',
          reject_offer: 'Rechazar',
          counter_offer: 'Contraoferta',
          offer_accepted: '¡Oferta aceptada!',
          offer_rejected: 'Oferta rechazada',
          offer_countered: 'Contraoferta enviada',
          your_offer: 'Tu oferta:',
          seller_response: 'Respuesta del vendedor:',
          // User type
          user_type: 'Tipo de Usuario',
          particular: 'Vendedor Particular',
          professional: 'Profesional',
          select_user_type: 'Selecciona tu tipo de usuario',
          cancel: 'Cancelar',
          noAds: 'Parece que aún no se han publicado anuncios...',
          notFound: 'Página No Encontrada',
          notFoundBackHome: 'Volver al inicio',
          notFoundDescription: 'La página que buscas no existe o ha sido movida. Por favor, revisa la URL o regresa a la página principal.',
          noResultsFound: 'No se encontraron resultados para tu búsqueda.',
          passwrd: 'Contraseña',
          phone: 'Teléfono Móvil',
          phone_examples: 'Ejemplos: +1 5551234567 (EE.UU.), +44 7911123456 (Reino Unido), +55 11999999999 (Brasil), +34 612345678 (España)',
          phone_format_error: 'Por favor, ingresa un número de teléfono internacional válido (ej: +1 5551234567, +55 11999999999)',
          phone_placeholder: '+34 612345678',
          password: 'Contraseña',
          passwordChanged: 'Contraseña cambiada exitosamente.',
          passwordChangeError: 'Error al cambiar la contraseña. Por favor, inténtalo de nuevo más tarde.',
          password_confirmation: 'Confirmar Contraseña',
          password_reset: 'Contraseña restablecida exitosamente. Ahora puedes iniciar sesión con tu nueva contraseña.',
          password_reset_error: 'Error al enviar el enlace de restablecimiento de contraseña. Por favor, inténtalo de nuevo más tarde.',
          password_reset_link_sent: 'Enlace para restablecer la contraseña enviado a tu correo. Por favor revisa tu bandeja de entrada.',
          postAd: 'Publicar un anuncio +',
          postAdButton: 'Publicar un anuncio',
          price: 'Precio',
          price_required: 'El precio es obligatorio o marca como negociable',
          priceNegotiable: 'Precio Negociable',          'Price Range': 'Rango de Precio',
          'Min': 'Mín',
          'Max': 'Máx',
          'All': 'Todos',
          'Newest First': 'Más Recientes',
          'Oldest First': 'Más Antiguos',
          'Price: Low to High': 'Precio: Menor a Mayor',
          'Price: High to Low': 'Precio: Mayor a Menor',
          'Most Viewed': 'Más Vistos',
          'Results': 'Resultados',          privacyDescription: 'Tu privacidad es importante para nosotros. Por favor, lee nuestra política de privacidad para entender cómo recopilamos, usamos y protegemos tu información.',
          privacyPolicy: 'Política de Privacidad',
          privacyPolicyLink: 'Política de Privacidad',
          profileUpdateError: 'Error al actualizar el perfil. Por favor, inténtalo de nuevo más tarde.',
          profileUpdated: 'Perfil actualizado exitosamente.',
          profileSettings: 'Configuración de Perfil',
          basicInformation: 'Información Básica',
          updateBasicInfo: 'Actualiza tu información personal',
          manageEmailSettings: 'Gestiona tu correo y verificación',
          managePhoneSettings: 'Gestiona tu teléfono y verificación',
          updatePasswordSecurity: 'Cambia tu contraseña para mantener tu cuenta segura',
          oauthLogin: 'Inicio de Sesión OAuth',
          enterName: 'Ingresa tu nombre',
          enterState: 'Ingresa tu estado',
          selectState: 'Selecciona tu provincia',
          updateProfile: 'Actualizar Perfil',
          emailAddress: 'Dirección de Email',
          enterEmail: 'Ingresa tu email',
          updateEmail: 'Actualizar Email',
          resendVerification: 'Reenviar Verificación',
          emailVerificationRequired: 'Se enviará un email de verificación a tu nueva dirección',
          phoneNumber: 'Número de Teléfono',
          updatePhone: 'Actualizar Teléfono',
          resendCode: 'Reenviar Código',
          verificationCode: 'Código de Verificación',
          verifyPhone: 'Verificar Teléfono',
          phoneVerificationRequired: 'Se enviará un código de verificación a tu teléfono',
          phoneVerificationCodeSent: 'Se ha enviado un código de verificación a tu teléfono. Por favor ingresa el código de 6 dígitos.',
          phoneVerificationSentTo: 'Enviamos un código de verificación a:',
          phoneVerifiedSuccess: '¡Teléfono verificado exitosamente! Redirigiendo al inicio de sesión...',
          verificationCodeResent: 'Código de verificación reenviado exitosamente.',
          enterVerificationCode: 'Por favor ingresa el código de verificación de 6 dígitos',
          didntReceiveCode: '¿No recibiste el código?',
          verify: 'Verificar Código',
          verifyNow: 'Verificar Ahora',
          phoneVerifyModal: 'Verificación de Teléfono',
          phoneAlreadyInUse: 'Número de teléfono en uso',
          phoneAlreadyInUseMessage: 'Este número de teléfono ya está registrado en otra cuenta. Por favor, usa un número diferente.',
          codeSentSuccess: 'Código de verificación enviado exitosamente',
          codeSentError: 'Error al enviar el código de verificación',
          codeVerifySuccess: 'Teléfono verificado exitosamente',
          codeVerifyError: 'Código de verificación inválido o expirado',
          resendCodeIn: 'Reenviar código en {{seconds}}s',
          resendCodeAvailable: 'Reenviar Código',
          enterCodePlaceholder: 'Ingresa código de 4 dígitos',
          codeExpiresWarning: 'El código expira en 60 segundos. Por favor ingrésalo rápidamente.',
          currentPassword: 'Contraseña Actual',
          enterCurrentPassword: 'Ingresa tu contraseña actual',
          newPassword: 'Nueva Contraseña',
          enterNewPassword: 'Ingresa nueva contraseña',
          confirmNewPassword: 'Confirma nueva contraseña',
          oauthAccount: 'Iniciaste sesión con {{provider}}. Los cambios de contraseña no están disponibles.',
          verified: 'Verificado',
          notVerified: 'No Verificado',
          register: 'Registrar',
          registerDescription: 'Crea tu cuenta para comenzar a publicar anuncios y explorar nuestro mercado. Completa el formulario a continuación para comenzar.',
          remember_me: 'Recuérdame',
          search: 'Buscar en el sitio...',
          searchButton: 'Buscar',
          seeAll: 'Ver todos >>',
          sign_in: 'Iniciar sesión',
          sign_in_with_google: 'Iniciar sesión con Google',
          sign_up: 'Registrarse',
          sign_up_with_google: 'Registrarse con Google',
          phone_verification_required: 'Verificación de Teléfono Requerida',
          phone_verification_required_message: 'Tu cuenta requiere verificación de teléfono antes de que puedas iniciar sesión. Esto nos ayuda a mantener la plataforma segura y prevenir spam.',
          verify_phone_now: 'Verificar Teléfono Ahora',
          speak_with_seller: 'Hablar con el vendedor',
          speak_with_seller_description: 'Si tienes alguna pregunta sobre este anuncio, puedes contactar directamente al vendedor por correo electrónico.',
          state: 'Estado',
          stateAll: 'Todos',
          termsAndConditions: 'Términos y Condiciones',
          termsAndConditionsLink: 'Términos y Condiciones',
          termsDescription: 'Por favor, lee nuestros términos y condiciones cuidadosamente antes de usar nuestro marketplace. Al usar nuestro sitio, aceptas cumplir con estos términos.',
          title: 'Título',
          token_invalid: 'Token inválido o expirado.',
          token_not_provided: 'Token no proporcionado.',
          user_not_found: 'Usuario no encontrado.',
          verifying: 'Verificando...',
          emailVerified: 'Correo electrónico verificado con éxito. Ahora puedes iniciar sesión.',
          view: 'Ver',
          viewers: 'Visitas',
          viewAd: 'Ver Anuncio',
          contacts: 'contactos',
          must_login_favorites: 'Debes iniciar sesión para agregar favoritos',
          must_login_messages: 'Debes iniciar sesión para enviar mensajes',
          interested_whatsapp: 'Hola, estoy interesado en tu anuncio:',
          welcome: '¡Bienvenido a nuestro marketplace! Aquí puedes comprar, vender, alquilar e intercambiar fácilmente. Disfruta explorando los anuncios y categorías más recientes hechos para ti.',
          welcomeBack: '¡Bienvenido de nuevo, {{name}}! Aquí puedes gestionar tus anuncios y tu perfil.',
          welcomeNewUser: '¡Bienvenido! Por favor, crea tu cuenta para empezar a publicar anuncios y explorar nuestro marketplace.',
          welcomeTitle: '¡Bienvenido a Terserah! 🎉',
          welcomeText: '¡Bienvenido a Terserah! Nos alegra darte la bienvenida a Terserah, tu nuevo espacio online donde puedes encontrar todo tipo de productos al mejor precio. Desde artículos de segunda mano en excelente estado hasta oportunidades únicas que no querrás perderte, Terserah es el lugar ideal para comprar y vender fácil, rápido y seguro. En nuestra plataforma puedes explorar una gran variedad de categorías: tecnología, moda, hogar, deportes, juguetes, vehículos y mucho más! Ya sea que estés buscando algo específico o simplemente navegando por curiosidad, estamos seguros de que encontrarás algo interesante. Además, si tienes productos que ya no usas, súbelos a Terserah y encuentra a alguien que los necesite. Recicla, gana dinero y ayuda al planeta al mismo tiempo! Gracias por confiar en nosotros. Comienza a explorar ahora y descubre todo lo que Terserah tiene para ti.',
          whatareYouLookingFor: '¿Qué estás buscando?',
          featuredAds: 'Anuncios Destacados ⭐',
          whatIsYourName: '¿Cuál es tu nombre?',
          // Categories
          'Electronics': 'Electrónica',
          'Smartphones': 'Smartphones',
          // Stats and How it Works
          'Active Ads': 'Anuncios Activos',
          'Categories': 'Categorías',
          '100% Free': '100% Gratis',
          'To Publish': 'Para Publicar',
          'How It Works': 'Cómo Funciona',
          'Search': 'Buscar',
          'Browse thousands of ads in all categories': 'Explora miles de anuncios en todas las categorías',
          'Contact': 'Contactar',
          'Message sellers directly to negotiate': 'Envía mensajes directamente a los vendedores para negociar',
          'Deal': 'Cerrar Trato',
          'Meet safely and complete your transaction': 'Reúnete de forma segura y completa tu transacción',
          'Recent Ads': 'Anuncios Recientes',
          'Computers and Laptops': 'Ordenadores y portátiles',
          'Consoles and Videogames': 'Consolas y videojuegos',
          'Cameras and Photography': 'Cámaras y fotografía',
          'Small Appliances': 'Electrodomésticos pequeños',
          'Home and Furniture': 'Hogar y Muebles',
          'Furniture': 'Muebles',
          'Decoration': 'Decoración',
          'Kitchen and Utensils': 'Cocina y utensilios',
          'Garden and Outdoor': 'Jardín y exterior',
          'Lighting': 'Iluminación',
          'Fashion and Accessories': 'Moda y Accesorios',
          'Clothing': 'Ropa',
          'Footwear': 'Calzado',
          'Bags and Backpacks': 'Bolsos y mochilas',
          'Watches and Jewelry': 'Relojes y joyería',
          'Accessories': 'Accesorios',
          'Motor': 'Motor',
          'Cars': 'Coches',
          'Motorcycles': 'Motos',
          'Vehicle Accessories': 'Accesorios para vehículo',
          'Spare Parts': 'Repuestos',
          'Tools and Maintenance': 'Herramientas y mantenimiento',
          'Leisure, Sports and Others': 'Ocio, Deporte y Otros',
          'Sports and Fitness': 'Deportes y fitness',
          'Bicycles': 'Bicicletas',
          'Musical Instruments': 'Instrumentos musicales',
          'Toys and Games': 'Juguetes y juegos',
          'Books and Collectibles': 'Libros y coleccionismo',
          // Services Category
          'Services': 'Alquiler y Servicios',
          'Cleaning & Housekeeping': 'Limpieza y Servicio Doméstico',
          'Construction & Renovation': 'Construcción y Renovación',
          'Education & Tutoring': 'Educación y Clases Particulares',
          'Events & Catering': 'Eventos y Catering',
          'Beauty & Wellness': 'Belleza y Bienestar',
          'Technical Support & IT': 'Soporte Técnico e IT',
          'Transportation & Delivery': 'Transporte y Entrega',
          'Legal & Consulting': 'Legal y Consultoría',
          'Photography & Design': 'Fotografía y Diseño',
          'Other Services': 'Otros Servicios',
          otherSellerAds: 'Otras ofertas del vendedor',
          
          // Common legal terms
          lastUpdated: 'Última actualización',
          company: 'PT World Systems Consulting',
          platform: 'Terserah',
          country: 'Indonesia',
          
          // Privacy Policy
          privacy_title: 'Política de Privacidad',
          privacy_introduction_title: 'Introducción',
          privacy_introduction_content: 'Esta Política de Privacidad explica cómo Terserah ("nosotros", "nos" o "nuestro") recopila, usa, divulga y protege la información personal de los usuarios ("usted") que acceden y utilizan nuestra plataforma en https://terserah.id. Al usar nuestros servicios, acepta la recopilación y el uso de información de acuerdo con esta política.',
          
          privacy_information_title: 'Información que Recopilamos',
          privacy_information_intro: 'Recopilamos varios tipos de información para proporcionar y mejorar nuestros servicios:',
          privacy_information_personal: 'Información Personal:',
          privacy_information_personal_content: 'Nombre, dirección de correo electrónico, número de teléfono, dirección, foto de perfil y otra información que proporcione al registrar una cuenta o publicar anuncios.',
          privacy_information_transactional: 'Información de Transacciones:',
          privacy_information_transactional_content: 'Detalles de las transacciones que realiza a través de nuestra plataforma, incluidos los anuncios que compra, vende u oferta.',
          privacy_information_technical: 'Información Técnica:',
          privacy_information_technical_content: 'Dirección IP, tipo de navegador, dispositivo utilizado, sistema operativo, páginas visitadas y horarios de acceso.',
          privacy_information_usage: 'Datos de Uso:',
          privacy_information_usage_content: 'Información sobre cómo utiliza nuestra plataforma, como búsquedas realizadas, anuncios vistos e interacciones con otros usuarios.',
          privacy_information_location: 'Datos de Ubicación:',
          privacy_information_location_content: 'Si lo permite, recopilamos información de su ubicación para mostrar anuncios relevantes según su ubicación geográfica.',
          privacy_user_provided: 'Información que Usted Proporciona',
          privacy_user_name: 'Nombre completo',
          privacy_user_phone: 'Número de teléfono',
          privacy_user_email: 'Dirección de correo electrónico',
          privacy_user_photo: 'Foto de perfil',
          privacy_user_listings: 'Información de anuncios (título, descripción, precio, imágenes)',
          privacy_auto_collected: 'Información Recopilada Automáticamente',
          privacy_auto_ip: 'Dirección IP y detalles de conexión',
          privacy_auto_device: 'Tipo y modelo de dispositivo',
          privacy_auto_browser: 'Tipo y versión de navegador',
          privacy_auto_usage: 'Páginas visitadas y patrones de uso',
          
          privacy_purpose_title: 'Propósito del Uso de la Información',
          privacy_purpose_intro: 'Utilizamos la información recopilada para:',
          privacy_purpose_platform: 'Proporcionar, operar y mantener nuestra plataforma.',
          privacy_purpose_personalize: 'Personalizar la experiencia del usuario mostrando anuncios relevantes.',
          privacy_purpose_communicate: 'Comunicarnos con usted sobre nuestros servicios, incluidas notificaciones, actualizaciones y soporte al cliente.',
          privacy_purpose_transactions: 'Facilitar transacciones entre usuarios.',
          privacy_purpose_security: 'Monitorear y mejorar la seguridad de la plataforma, incluida la detección y prevención de fraudes.',
          privacy_purpose_analytics: 'Analizar el uso de la plataforma para mejorar nuestros servicios.',
          privacy_purpose_legal: 'Cumplir con obligaciones legales y regulatorias aplicables.',
          privacy_purpose_accounts: 'Crear y administrar cuentas de usuario',
          privacy_purpose_display: 'Mostrar anuncios relevantes según ubicación y preferencias',
          privacy_purpose_improve: 'Mejorar y optimizar la plataforma',
          privacy_purpose_prevent: 'Prevenir fraudes y garantizar la seguridad',
          privacy_purpose_comply: 'Cumplir con requisitos legales y regulatorios',
          
          privacy_legal_title: 'Base Legal para el Procesamiento de Datos',
          privacy_legal_intro: 'Procesamos sus datos personales en base a las siguientes bases legales:',
          privacy_legal_contract: 'Ejecución del contrato con usted al utilizar nuestros servicios.',
          privacy_legal_interest: 'Nuestro interés legítimo en operar y mejorar la plataforma.',
          privacy_legal_consent: 'Su consentimiento explícito para la recolección y procesamiento de datos',
          privacy_legal_compliance: 'Cumplimiento de obligaciones legales.',
          privacy_legal_business: 'Intereses comerciales legítimos para mejorar nuestros servicios',
          
          privacy_sharing_title: 'Compartir Información con Terceros',
          privacy_sharing_intro: 'No vendemos su información personal. Sin embargo, podemos compartir su información en las siguientes situaciones:',
          privacy_sharing_no_sell: 'No vendemos su información personal a terceros.',
          privacy_sharing_providers: 'Proveedores de servicios que nos ayudan a operar la plataforma (alojamiento, analítica)',
          privacy_sharing_providers_content: 'Podemos compartir información con proveedores de servicios que nos ayudan a operar la plataforma, como proveedores de alojamiento, servicios de pago y herramientas analíticas.',
          privacy_sharing_authorities: 'Autoridades policiales o reguladoras cuando lo exija la ley',
          privacy_sharing_partners: 'Podemos compartir datos anonimizados con socios para fines de analítica y mejora.',
          privacy_sharing_users: 'Otros Usuarios:',
          privacy_sharing_users_content: 'Cierta información, como nombre, correo electrónico y número de teléfono, puede ser visible para otros usuarios cuando publica anuncios o contacta a vendedores.',
          privacy_sharing_legal: 'Cumplimiento Legal:',
          privacy_sharing_legal_content: 'Podemos divulgar su información si lo requiere la ley o para proteger nuestros derechos, propiedad o seguridad, la de nuestros usuarios u otros.',
          privacy_sharing_business: 'Transferencias Comerciales:',
          privacy_sharing_business_content: 'En caso de fusión, adquisición o venta de nuestros activos, la información del usuario puede transferirse como parte de esa transacción.',
          
          privacy_storage_title: 'Almacenamiento y Seguridad de Datos',
          privacy_storage_intro: 'Tomamos medidas razonables para proteger su información personal contra acceso, alteración, divulgación o destrucción no autorizados. Nuestros datos se almacenan en servidores seguros, y aplicamos cifrado y otras medidas de seguridad para proteger su información.',
          privacy_storage_https: 'Uso de cifrado HTTPS para la transmisión de datos',
          privacy_storage_servers: 'Servidores seguros con acceso restringido',
          privacy_storage_access: 'Acceso limitado de empleados a datos personales según necesidad',
          privacy_storage_warning: 'Sin embargo, ningún método de transmisión por Internet o almacenamiento electrónico es 100% seguro. Aunque nos esforzamos por usar medios comercialmente aceptables para proteger su información personal, no podemos garantizar su seguridad absoluta.',
          
          privacy_retention_title: 'Retención de Datos',
          privacy_retention_content: 'Conservamos su información personal mientras su cuenta esté activa o según sea necesario para proporcionar nuestros servicios. Después de eliminar su cuenta, eliminaremos o anonimizaremos su información personal, a menos que la ley nos obligue a conservarla.',
          privacy_retention_intro: 'Conservamos sus datos según los siguientes principios:',
          privacy_retention_active: 'Los datos de cuenta activa se conservan mientras su cuenta esté activa',
          privacy_retention_legal: 'Algunos datos pueden conservarse para cumplir con obligaciones legales',
          privacy_retention_deletion: 'Puede solicitar la eliminación de su cuenta en cualquier momento a través de la configuración de su cuenta.',
          
          privacy_rights_title: 'Sus Derechos',
          privacy_rights_intro: 'Tiene los siguientes derechos relacionados con su información personal:',
          privacy_rights_access: 'Acceso:',
          privacy_rights_access_content: 'Puede solicitar una copia de la información personal que tenemos sobre usted.',
          privacy_rights_correction: 'Corrección:',
          privacy_rights_correction_content: 'Puede solicitarnos que actualicemos o corrijamos su información personal que sea inexacta o incompleta.',
          privacy_rights_correct: 'Solicitar corrección de datos personales inexactos',
          privacy_rights_withdraw: 'Retirar el consentimiento para el procesamiento de datos en cualquier momento',
          privacy_rights_delete: 'Solicitar la eliminación de sus datos personales',
          privacy_rights_complain: 'Presentar una queja ante una autoridad de protección de datos',
          privacy_rights_deletion: 'Eliminación:',
          privacy_rights_deletion_content: 'Puede solicitarnos que eliminemos su información personal, sujeto a ciertas condiciones.',
          privacy_rights_objection: 'Objeción:',
          privacy_rights_objection_content: 'Puede oponerse al procesamiento de su información personal en ciertas situaciones.',
          privacy_rights_restriction: 'Restricción:',
          privacy_rights_restriction_content: 'Puede solicitarnos que restrinjamos el procesamiento de su información personal.',
          privacy_rights_portability: 'Portabilidad de Datos:',
          privacy_rights_portability_content: 'Puede solicitar una copia de sus datos en un formato legible por máquina.',
          privacy_rights_exercise: 'Para ejercer estos derechos, contáctenos en',
          privacy_rights_contact: 'Para ejercer cualquiera de estos derechos, contáctenos en info@terserah.id',
          
          privacy_cookies_title: 'Cookies y Tecnologías de Seguimiento',
          privacy_cookies_content: 'Utilizamos cookies y tecnologías de seguimiento similares para mejorar la experiencia del usuario y analizar el tráfico del sitio web. Las cookies son pequeños archivos almacenados en su dispositivo que nos ayudan a reconocerlo y recordar sus preferencias. Puede administrar sus preferencias de cookies a través de la configuración de su navegador, pero deshabilitar las cookies puede afectar la funcionalidad de nuestra plataforma.',
          privacy_cookies_intro: 'Utilizamos cookies y tecnologías similares para:',
          privacy_cookies_experience: 'Mejorar la experiencia del usuario y recordar preferencias',
          privacy_cookies_analyze: 'Analizar el tráfico y patrones de uso',
          privacy_cookies_security: 'Mantener la seguridad y prevenir fraudes',
          privacy_cookies_disable: 'Puede administrar las preferencias de cookies en la configuración de su navegador.',
          
          privacy_thirdparty_title: 'Enlaces de Terceros',
          privacy_thirdparty_content: 'Nuestra plataforma puede contener enlaces a sitios web de terceros. No somos responsables de las prácticas de privacidad o el contenido de dichos sitios web. Le recomendamos que lea las políticas de privacidad de cada sitio web que visite.',
          
          privacy_changes_title: 'Cambios a esta Política de Privacidad',
          privacy_changes_content: 'Podemos actualizar esta Política de Privacidad de vez en cuando para reflejar cambios en nuestras prácticas o por razones operativas, legales o regulatorias. Le notificaremos cualquier cambio publicando la nueva Política de Privacidad en esta página y actualizando la fecha de "Última actualización" en la parte superior.',
          
          privacy_contact_title: 'Contáctenos',
          privacy_contact_content: 'Si tiene preguntas o inquietudes sobre esta Política de Privacidad o nuestras prácticas de privacidad, contáctenos en:',
          privacy_contact_intro: 'Para preguntas sobre esta Política de Privacidad o nuestras prácticas de privacidad, contáctenos:',
          privacy_contact_email: 'Correo: info@terserah.id',
          privacy_contact_address: 'Dirección: PT World Systems Consulting, Indonesia',
          
          // Terms and Conditions
          terms_title: 'Términos y Condiciones',
          
          terms_acceptance_title: 'Aceptación de los Términos',
          terms_acceptance_content: 'Al acceder o utilizar la plataforma Terserah ("Plataforma"), acepta estar sujeto a estos Términos y Condiciones. Si no está de acuerdo con estos términos, no utilice nuestra Plataforma.',
          
          terms_service_title: 'Descripción del Servicio',
          terms_service_content: 'Terserah es un mercado en línea que facilita la compra, venta, alquiler e intercambio de bienes y servicios entre usuarios en Indonesia. La plataforma no actúa como vendedor o comprador, sino como intermediario que conecta a los usuarios.',
          terms_service_warning: 'Terserah no es responsable de las transacciones entre usuarios. Todas las transacciones son responsabilidad exclusiva de compradores y vendedores.',
          
          terms_eligibility_title: 'Elegibilidad',
          terms_eligibility_content: 'Debe tener al menos 18 años o tener el permiso de sus padres/tutores para utilizar nuestra Plataforma. Al registrarse, garantiza que tiene la autoridad legal para celebrar un acuerdo vinculante.',
          terms_eligibility_age: 'Tener al menos 18 años o contar con el consentimiento de padres/tutores.',
          terms_eligibility_accurate: 'Proporcionar información precisa y veraz durante el registro.',
          terms_eligibility_one_account: 'Mantener solo una cuenta por persona.',
          
          terms_accounts_title: 'Cuentas de Usuario',
          terms_accounts_registration: 'Registro:',
          terms_accounts_registration_content: 'Debe crear una cuenta para acceder a algunas funciones de la Plataforma. Es responsable de proporcionar información precisa y completa durante el proceso de registro.',
          terms_accounts_security: 'Seguridad de la Cuenta:',
          terms_accounts_security_content: 'Es responsable de mantener la confidencialidad de las credenciales de su cuenta y de todas las actividades que ocurran bajo su cuenta. Infórmenos de inmediato si hay un uso no autorizado.',
          terms_accounts_termination: 'Terminación de Cuenta:',
          terms_accounts_termination_content: 'Nos reservamos el derecho de suspender o terminar su cuenta en cualquier momento si viola estos términos o participa en actividades ilegales o inapropiadas.',
          terms_accounts_responsible: 'Es responsable de todas las actividades bajo su cuenta.',
          terms_accounts_terminate: 'Nos reservamos el derecho de suspender o terminar cuentas que violen nuestros términos.',
          terms_accounts_prohibited: 'Crear múltiples cuentas o compartir credenciales de cuenta está prohibido.',
          
          terms_listings_title: 'Listados y Contenido',
          terms_listings_intro: 'Los usuarios tienen prohibido publicar anuncios de los siguientes artículos:',
          terms_listings_illegal: 'Drogas, narcóticos o sustancias ilegales.',
          terms_listings_weapons: 'Armas de fuego, armas o explosivos.',
          terms_listings_counterfeit: 'Productos falsificados, pirateados o fraudulentos.',
          terms_listings_animals: 'Animales en peligro de extinción o protegidos sin la autorización adecuada.',
          terms_listings_adult: 'Contenido para adultos o material sexualmente explícito.',
          terms_listings_review: 'Nos reservamos el derecho de revisar y eliminar cualquier listado que viole estos términos.',
          terms_listings_responsibility: 'Responsabilidad del Usuario:',
          terms_listings_responsibility_content: 'Los usuarios son totalmente responsables del contenido que publican, incluidos anuncios, imágenes, descripciones y otra información. Garantiza que su contenido no infringe los derechos de terceros ni las leyes aplicables.',
          terms_listings_prohibited: 'Artículos Prohibidos:',
          terms_listings_prohibited_content: 'No puede publicar anuncios de artículos prohibidos por la ley indonesia o contrarios a nuestra política, incluidos, entre otros: drogas, armas de fuego, artículos robados, productos falsificados o contenido ofensivo o ilegal.',
          terms_listings_moderation: 'Moderación de Contenido:',
          terms_listings_moderation_content: 'Nos reservamos el derecho de revisar, editar o eliminar cualquier contenido que viole estos términos o se considere inapropiado, sin previo aviso.',
          
          terms_transactions_title: 'Transacciones',
          terms_transactions_responsibility: 'Responsabilidad del Usuario:',
          terms_transactions_responsibility_content: 'Las transacciones que ocurren a través de la Plataforma son entre el comprador y el vendedor. Terserah no es responsable de la calidad, seguridad o legalidad de los artículos comercializados, ni de la capacidad del vendedor para completar la transacción.',
          terms_transactions_disputes: 'Resolución de Disputas:',
          terms_transactions_disputes_content: 'Los usuarios son responsables de resolver las disputas que puedan surgir de sus transacciones. Podemos ayudar a facilitar la comunicación, pero no somos responsables de mediar o resolver disputas.',
          terms_transactions_between: 'Todas las transacciones son directamente entre compradores y vendedores.',
          terms_transactions_no_guarantee: 'Terserah no garantiza la calidad, seguridad o legalidad de los artículos listados.',
          terms_transactions_risks: 'Los usuarios asumen todos los riesgos asociados con las transacciones y deben ejercer precaución.',
          
          terms_fees_title: 'Tarifas',
          terms_fees_content: 'El uso básico de la Plataforma es gratuito. Sin embargo, podemos cobrar tarifas por servicios premium o funciones adicionales en el futuro. Los cambios en las tarifas se anunciarán en la Plataforma.',
          terms_fees_current: 'Actualmente, publicar y navegar anuncios en Terserah es completamente gratis.',
          terms_fees_future: 'Nos reservamos el derecho de introducir tarifas para funciones premium en el futuro, con aviso previo a los usuarios.',
          
          terms_conduct_title: 'Conducta del Usuario',
          terms_conduct_intro: 'Al utilizar la Plataforma, acepta no:',
          terms_conduct_laws: 'Violar leyes o regulaciones aplicables.',
          terms_conduct_fraud: 'Participar en actividades fraudulentas, engañosas o engañosas.',
          terms_conduct_harass: 'Acosar, amenazar, difamar o abusar de otros usuarios.',
          terms_conduct_manipulate: 'Intentar manipular precios, reseñas o clasificaciones de búsqueda.',
          terms_conduct_circumvent: 'Eludir o interferir con las funciones de seguridad de la Plataforma.',
          terms_conduct_others: 'Acosar, amenazar o abusar de otros usuarios.',
          terms_conduct_interfere: 'Interferir o dañar la funcionalidad de la Plataforma.',
          terms_conduct_bots: 'Usar bots, scrapers u otras herramientas automatizadas sin nuestro permiso.',
          terms_conduct_impersonate: 'Hacerse pasar por otra persona o entidad.',
          
          terms_ip_title: 'Propiedad Intelectual',
          terms_ip_content: 'Todo el contenido, logotipos, marcas comerciales y otros materiales en la Plataforma son propiedad de PT World Systems Consulting o sus licenciantes y están protegidos por las leyes de propiedad intelectual. No puede usar, reproducir o distribuir nuestro contenido sin permiso por escrito.',
          
          terms_liability_title: 'Limitación de Responsabilidad',
          terms_liability_intro: 'En la medida permitida por la ley:',
          terms_liability_asis: 'Terserah proporciona la Plataforma "tal cual" sin ninguna garantía, expresa o implícita.',
          terms_liability_nodamages: 'No somos responsables de daños directos, indirectos, incidentales o consecuentes que surjan del uso o la imposibilidad de usar la Plataforma.',
          terms_liability_noliability: 'No somos responsables de las acciones o negligencias de los usuarios, ni de las transacciones realizadas a través de la Plataforma.',
          terms_liability_not_liable: 'Terserah no es responsable de pérdidas, daños o disputas que surjan de las transacciones de usuarios.',
          terms_liability_not_responsible: 'No somos responsables de la precisión, calidad o legalidad del contenido publicado por los usuarios.',
          
          terms_privacy_title: 'Privacidad',
          terms_privacy_content: 'El uso de su información personal se rige por nuestra Política de Privacidad, que forma parte de estos Términos y Condiciones. Lea la Política de Privacidad para comprender cómo recopilamos, usamos y protegemos sus datos.',
          
          terms_termination_title: 'Terminación',
          terms_termination_content: 'Nos reservamos el derecho de suspender o terminar su acceso a la Plataforma en cualquier momento, con o sin causa, y sin previo aviso. Después de la terminación, debe dejar de usar la Plataforma, y todos los derechos otorgados a usted bajo estos términos cesarán.',
          
          terms_law_title: 'Ley Aplicable',
          terms_law_content: 'Estos Términos y Condiciones se rigen e interpretan de acuerdo con las leyes de Indonesia. Cualquier disputa que surja de o esté relacionada con estos términos se resolverá en los tribunales de Indonesia.',
          terms_governing_title: 'Ley Aplicable',
          terms_governing_content: 'Estos Términos y Condiciones se rigen e interpretan de acuerdo con las leyes de Indonesia. Cualquier disputa se resolverá en los tribunales indonesios.',
          
          terms_contact_title: 'Contáctenos',
          terms_contact_content: 'Si tiene preguntas sobre estos Términos y Condiciones, contáctenos en:',
          terms_contact_intro: 'Si tiene alguna pregunta o inquietud sobre estos Términos y Condiciones, contáctenos:',
          terms_contact_email: 'Correo: info@terserah.id',
          terms_contact_address: 'Dirección: PT World Systems Consulting, Indonesia',

          // Notifications
          notifications_title: 'Notificaciones',
          notifications_none: 'Sin notificaciones',
          notifications_mark_read: 'Marcar como leído',
          notifications_mark_all_read: 'Marcar todas como leídas',
          notifications_delete: 'Eliminar',
          notifications_new: 'Nueva notificación',
          notification_message: 'te envió un mensaje',
          notification_offer_received: 'te envió una oferta',
          notification_offer_accepted: 'aceptó tu oferta',
          notification_offer_rejected: 'rechazó tu oferta',
          notification_offer_countered: 'hizo una contraoferta',
          notification_review_received: 'te dejó una reseña',
          notification_ad_sold: 'Tu anuncio ha sido marcado como vendido',
          notification_ad_expired: 'Tu anuncio ha expirado',
          notification_price_drop: 'Rebaja de precio en un anuncio guardado',
          notification_saved_search_match: 'Nuevo anuncio coincide con tu búsqueda guardada',
          notification_follow_new_ad: 'publicó un nuevo anuncio',

          // Offers
          offers_title: 'Ofertas',
          offers_none: 'Aún no hay ofertas',
          offers_received: 'Ofertas Recibidas',
          offers_sent: 'Ofertas Enviadas',
          offers_make: 'Hacer Oferta',
          offers_accept: 'Aceptar',
          offers_reject: 'Rechazar',
          offers_counter: 'Contraoferta',
          offers_pending: 'Pendiente',
          offers_accepted: 'Aceptada',
          offers_rejected: 'Rechazada',
          offers_countered: 'Contraofertar',
          offers_expired: 'Expirada',
          offers_amount: 'Monto de Oferta',
          offers_message: 'Mensaje',
          offers_expires: 'Expira en',
          offers_expired_on: 'Expiró el',
          offers_status: 'Estado',

          // Verification Badges
          verification_elite: 'Vendedor Elite',
          verification_pro: 'Vendedor Pro',
          verification_trusted: 'Vendedor Confiable',
          verification_verified: 'Usuario Verificado',
          verification_new: 'Usuario Nuevo',
          verification_level: 'Nivel de Verificación',

          // Biography
          biography: 'Biografía',
          biographyPlaceholder: 'Cuéntanos sobre ti...',
          characters: 'caracteres',
          
          // Reviews
          reviews: 'reseñas',
          review: 'reseña',
          leave_review: 'Dejar una reseña',
          leave_review_title: 'Dejar una reseña',
          review_rating_label: 'Calificación *',
          review_comment_label: 'Comentario (opcional)',
          review_comment_placeholder: 'Comparte tu experiencia con este usuario...',
          review_submit: 'Enviar reseña',
          review_submitting: 'Enviando...',
          review_success: 'Reseña enviada exitosamente',
          review_error: 'Error al enviar la reseña',
          review_rating_required: 'Por favor selecciona una calificación',
          review_rating_very_bad: 'Muy malo',
          review_rating_bad: 'Malo',
          review_rating_average: 'Regular',
          review_rating_good: 'Bueno',
          review_rating_excellent: 'Excelente',
          reviews_title: 'Reseñas ({{count}})',
          reviews_loading: 'Cargando reseñas...',
          reviews_empty: 'Este usuario aún no tiene reseñas',
          reviews_load_more: 'Cargar más reseñas',
          reviews_ad_reference: '📦 Anuncio: {{title}}',
          reviews_user_label: 'Usuario',
          reviews_today: 'Hoy',
          reviews_yesterday: 'Ayer',
          reviews_days_ago: 'Hace {{days}} días',
          reviews_weeks_ago: 'Hace {{weeks}} semanas',
          reviews_months_ago: 'Hace {{months}} meses',
          reviews_years_ago: 'Hace {{years}} años',
          
          // Social Share
          share: 'Compartir',
          share_title_default: 'Mira este anuncio en Terserah',
          share_description_default: 'Encontré este anuncio interesante en Terserah',
          share_link_copied: 'Copiado!',
          share_copy_link: 'Copiar enlace',
          
          // Report Ad
          report_ad: '🚩 Reportar anuncio',
          report_ad_title: 'Reportar anuncio',
          report_ad_subtitle: 'Ayúdanos a mantener la comunidad segura reportando contenido inapropiado',
          report_ad_reason_label: '¿Cuál es el motivo del reporte?',
          report_ad_reason_spam: '📢 Spam o contenido repetitivo',
          report_ad_reason_inappropriate: '🚫 Contenido inapropiado u ofensivo',
          report_ad_reason_fraud: '⚠️ Posible fraude o estafa',
          report_ad_reason_duplicate: '📋 Anuncio duplicado',
          report_ad_reason_other: '❓ Otro motivo',
          report_ad_details_label: 'Detalles adicionales (opcional)',
          report_ad_details_placeholder: 'Proporciona más información sobre el problema...',
          report_ad_cancel: 'Cancelar',
          report_ad_submit: 'Enviar Reporte',
          report_ad_submitting: 'Enviando...',
          report_ad_success: 'Reporte enviado exitosamente. Nuestro equipo lo revisará pronto.',
          report_ad_error: 'Error al enviar reporte',
          report_ad_reason_required: 'Por favor selecciona un motivo',
          report_ad_login_required: 'Debes iniciar sesión para reportar anuncios',

          // Follow System
          follow: 'Seguir',
          following: 'Siguiendo',
          unfollow: 'Dejar de seguir',
          followers: 'Seguidores',
          followersCount: '{{count}} seguidores',
          followingCount: '{{count}} siguiendo',
          followingFeed: 'Feed de Seguidos',
          noFollowing: 'Aún no sigues a nadie',
          startFollowing: 'Sigue usuarios para ver sus anuncios aquí',
          
          // User Profile
          user_profile: 'Perfil de Usuario',
          user_profile_description: 'Ver información y estadísticas del perfil de usuario',
          error_loading_profile: 'Error al cargar el perfil',
          bio_placeholder: 'Cuéntanos sobre ti...',
          edit_bio: 'Editar Bio',
          save_bio: 'Guardar',
          bio_max_length: 'La bio debe tener menos de 500 caracteres',
          error_saving_bio: 'Error al guardar la bio',
          no_bio_yet: 'Añade una bio para contarle a la gente sobre ti',
          no_bio: 'Este usuario aún no ha añadido una bio',
          member_since: 'Miembro desde',
          
          // App Download
          download_android_app: 'Descargar App Android',
          download_ios_app: 'Descargar App iOS',
          get_it_on: 'DISPONIBLE EN',
          download_on: 'Descargar en',
          
          // Search
          searchPlaceholder: 'Buscar productos...',
          suggestions: 'Sugerencias',
          recentSearches: 'Búsquedas Recientes',
          popularSearches: 'Búsquedas Populares',
          relatedSearches: 'Búsquedas Relacionadas',
          clearHistory: 'Borrar Historial',
          noRecentSearches: 'No hay búsquedas recientes',
          results: 'resultados',
          
          // Empty States
          'No data available': 'No hay datos disponibles',
          'There is no content to display at the moment': 'No hay contenido para mostrar en este momento',
          'Try adjusting your filters or search terms': 'Intenta ajustar tus filtros o términos de búsqueda',
          'Start a conversation by contacting a seller': 'Inicia una conversación contactando a un vendedor',
          'Browse ads': 'Explorar anuncios',
          'Save ads you like to find them easily later': 'Guarda los anuncios que te gusten para encontrarlos fácilmente después',
          'Explore ads': 'Explorar anuncios',
          'We\'ll notify you when something happens': 'Te notificaremos cuando algo suceda',
          'Try different keywords or remove some filters': 'Prueba con palabras clave diferentes o elimina algunos filtros',
          'Clear filters': 'Limpiar filtros',
          'Follow users to see their ads in your personalized feed': 'Sigue usuarios para ver sus anuncios en tu feed personalizado',
          'Find users': 'Encontrar usuarios',
          'Buyers can make offers on your negotiable items': 'Los compradores pueden hacer ofertas en tus artículos negociables',
          'Something went wrong': 'Algo salió mal',
          'Please try again later or contact support': 'Por favor, inténtalo de nuevo más tarde o contacta con soporte',
          'Retry': 'Reintentar',
          
          // Terms acceptance messages
          agree_terms_privacy: 'Acepto los Términos y Condiciones y la Política de Privacidad',
          by_posting_agree_terms: 'Al publicar un artículo, aceptas los',
          terms_and: 'Términos y Condiciones',
          
          // Category translations
          'Vehicles': 'Vehículos',
          'Trucks': 'Camiones',
          'Buses': 'Autobuses',
          'Boats': 'Barcos',
          'Vehicle Parts': 'Repuestos',
          'Vehicle Services': 'Servicios de Vehículos',
          'Heavy Machinery': 'Maquinaria Pesada',
          'Other Vehicles': 'Otros Vehículos',
          'Property': 'Propiedades',
          'Houses': 'Casas',
          'Apartments': 'Apartamentos',
          'Land': 'Terrenos',
          'Commercial Property': 'Propiedad Comercial',
          'Villas': 'Villas',
          'Boarding Houses': 'Pensiones',
          'Offices': 'Oficinas',
          'Warehouses': 'Almacenes',
          'Shops': 'Locales Comerciales',
          'Other Property': 'Otras Propiedades',
          'Phones & Tablets': 'Teléfonos y Tabletas',
          'Computers & Laptops': 'Computadoras y Portátiles',
          'TVs & Audio': 'TVs y Audio',
          'Cameras': 'Cámaras',
          'Gaming': 'Videojuegos',
          'Smart Home': 'Casa Inteligente',
          'Wearables': 'Dispositivos Portátiles',
          'Drones': 'Drones',
          'Other Electronics': 'Otros Electrónicos',
          'Fashion & Beauty': 'Moda y Belleza',
          'Mens Fashion': 'Moda Masculina',
          'Womens Fashion': 'Moda Femenina',
          'Kids Fashion': 'Moda Infantil',
          'Bags & Luggage': 'Bolsos y Maletas',
          'Shoes': 'Zapatos',
          'Watches': 'Relojes',
          'Jewelry': 'Joyería',
          'Beauty Products': 'Productos de Belleza',
          'Skincare': 'Cuidado de la Piel',
          'Other Fashion': 'Otra Moda',
          'Hobbies & Sports': 'Pasatiempos y Deportes',
          'Sports Equipment': 'Equipamiento Deportivo',
          'Art & Crafts': 'Arte y Manualidades',
          'Collectibles': 'Coleccionables',
          'Outdoor Gear': 'Equipo para Exteriores',
          'Fishing': 'Pesca',
          'Cycling': 'Ciclismo',
          'Gym & Fitness': 'Gimnasio y Fitness',
          'Board Games': 'Juegos de Mesa',
          'Other Hobbies': 'Otros Pasatiempos',
          'Home & Living': 'Hogar y Vida',
          'Home Appliances': 'Electrodomésticos',
          'Kitchen & Dining': 'Cocina y Comedor',
          'Bedding': 'Ropa de Cama',
          'Home Decor': 'Decoración del Hogar',
          'Garden & Outdoor': 'Jardín y Exterior',
          'Tools & DIY': 'Herramientas y Bricolaje',
          'Bathroom': 'Baño',
          'Other Home': 'Otro Hogar',
          'Home Services': 'Servicios del Hogar',
          'Repair Services': 'Servicios de Reparación',
          'Construction': 'Construcción',
          'Moving Services': 'Servicios de Mudanza',
          'Cleaning Services': 'Servicios de Limpieza',
          'Beauty Services': 'Servicios de Belleza',
          'Event Services': 'Servicios de Eventos',
          'Photography': 'Fotografía',
          'Legal Services': 'Servicios Legales',
          'Jobs': 'Empleos',
          'Full Time Jobs': 'Empleos de Tiempo Completo',
          'Part Time Jobs': 'Empleos de Medio Tiempo',
          'Freelance': 'Trabajo Autónomo',
          'Internships': 'Prácticas',
          'Remote Work': 'Trabajo Remoto',
          'IT & Software': 'TI y Software',
          'Sales & Marketing': 'Ventas y Marketing',
          'Hospitality': 'Hospitalidad',
          'Education': 'Educación',
          'Other Jobs': 'Otros Empleos',
          'Food & Beverages': 'Comida y Bebidas',
          'Home Cooking': 'Comida Casera',
          'Catering': 'Catering',
          'Snacks': 'Aperitivos',
          'Cakes & Bakery': 'Pasteles y Panadería',
          'Beverages': 'Bebidas',
          'Healthy Food': 'Comida Saludable',
          'Traditional Food': 'Comida Tradicional',
          'Frozen Food': 'Comida Congelada',
          'Ingredients': 'Ingredientes',
          'Other F&B': 'Otra Comida',
          'Education & Books': 'Educación y Libros',
          'Textbooks': 'Libros de Texto',
          'Novels & Fiction': 'Novelas y Ficción',
          'Non-Fiction Books': 'Libros de No Ficción',
          'Comics & Manga': 'Cómics y Manga',
          'Children Books': 'Libros Infantiles',
          'Online Courses': 'Cursos en Línea',
          'Stationery': 'Papelería',
          'Magazines': 'Revistas',
          'Imported Books': 'Libros Importados',
          'E-Books & Audiobooks': 'Libros Electrónicos y Audiolibros',
        }
      }
    },
    lng: 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;